(function (root, factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define([], function (vuecallback) {
            factory(function (api) {
                root.CP = api;
                root.cloudplate = root.CP._core;
                if (window) {
                    window.CP = api;
                    window.cloudplate = root.CP._core;
                }
                root.CP.start = 1;
                if (window.top !== window) {
                    try{
                        if(!window.top.CP){
                            window.top.CP = api;
                            window.top.cloudplate = root.CP._core;
                            window.top.CP.start = 1;
                        }
                    }catch(e){
                        console.log(e);
                    }
                    
                }
                //root.CP._init();
                vuecallback && vuecallback();
            });
        });
    } else if (typeof exports === 'object') {
        module.exports = function (vuecallback) {
            factory(function (api) {
                root.CP = api;
                root.cloudplate = root.CP._core;
                if (window) {
                    window.CP = api;
                    window.cloudplate = root.CP._core;
                }
                root.CP.start = 1;
                if (window.top !== window) {
                    try{
                        if(!window.top.CP){
                            window.top.CP = api;
                            window.top.cloudplate = root.CP._core;
                            window.top.CP.start = 1;
                        }
                    }catch(e){
                        console.log(e);
                    }
                    
                }
                //root.CP._init();
                vuecallback && vuecallback();
                return api;
            })
        };
    } else {
        factory(function (api) {
            root.CP = api;
            root.cloudplate = root.CP._core;
            if (window) {
                window.CP = api;
                window.cloudplate = root.CP._core;
            }
            if (window.top !== window) {
                    try{
                        if(!window.top.CP){
                            window.top.CP = api;
                            window.top.cloudplate = root.CP._core;
                            window.top.CP.start = 1;
                        }
                    }catch(e){
                        console.log(e);
                    }
                    
                }
            root.CP.start = 1;
        });
    }
})(this, function (initcallback) {
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
    var _cp_config = {
        common_file_path: 'https://open.cnjxol.com/jssdk/',
        wx_api_urls: {
            "T_JH_S_JH": window.location.protocol + '//cliser.jhnews.com.cn/b-app/c/share/wechatSignature',
            "T_JH_S_JD": window.location.protocol + '//jdcliser.jhnews.com.cn/b-app/c/share/wechatSignature',
            "T_GOV_S_WZ": window.location.protocol + '//trsapi.wzrb.com.cn/hybapp/c/share/wechatSignature',
            "T_GOV_S_KWZ": window.location.protocol + '//wzwbapp.wzrb.com.cn/hybapp/c/share/wechatSignature',
            "T_GOV_S_JROJK": window.location.protocol + '//trsapi.wzrb.com.cn/hybapp/c/share/wechatSignature',
            "T_GOV_S_WDXW": window.location.protocol + '//wdapp.wzrb.com.cn/hybapp/c/share/wechatSignature',
            "T_GOV_S_WZCS": window.location.protocol + '//trsapitest.wzrb.com.cn/hybapp/c/share/wechatSignature',
        },
        dd_api_url: 'https://g.alicdn.com/dingding/open-develop/1.9.0/dingtalk.js',
        version: 'trs v1.8.4',
        debug: false,
        yun_dun_url: { url: 'https://acstatic-dun.126.net/tool.min.js' },
        download_url: { zjxw: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.zhejiangdaily', h24: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.cmstop.qjwb', wx: 'http://sj.qq.com/myapp/detail.htm?apkName=com.tencent.mm', jxrb: '', xsb_keqiaotong: 'https://vapp.tmuyun.com/webDetails/download.html?tenant_id=2', xsb_iwenling: 'https://vapp.tmuyun.com/webDetails/download.html?tenant_id=3', xsb_tiantai: 'http://ttapp.tgzx.net.cn/webDetails/download.html?tenant_id=5', xsb_muguang: 'https://vapp.tmuyun.com/webDetails/download.html?tenant_id=6', xsb_jingning: 'https://vapp.tmuyun.com/webDetails/download.html?tenant_id=4', xsb_haigang: 'https://vapp.tmuyun.com/webDetails/download.html?tenant_id=7', xsb_lishui: 'https://vapp.tmuyun.com/webDetails/download.html?tenant_id=10', xsb_nanxun: 'https://vapp.tmuyun.com/webDetails/download.html?tenant_id=11', xsb_nayong: 'https://vapp.tmuyun.com/webDetails/download.html?tenant_id=12', xsb_fuquan: 'https://vapp.tmuyun.com/webDetails/download.html?tenant_id=13' },
        _open_params: { zjxw: { link: '' }, h24: { protocol: 'h24app', link: '' }, wx: {}, jxrb: {}, xsb_keqiaotong: { protocol: 'zjonlinekeqiaotong', link: '' }, xsb_iwenling: { protocol: 'zjonlineiwenling', link: '' }, xsb_tiantai: { protocol: 'zjonlinetiantai', link: '' }, xsb_muguang: { protocol: 'zjonlinemuguang', link: '' }, xsb_jingning: { protocol: 'zjonlinejingning', link: '' }, xsb_haigang: { protocol: 'zjonlinehaigang', link: '' }, xsb_lishui: { protocol: 'zjonlinelishui', link: '' }, xsb_nanxun: { protocol: 'zjonlinenanxun', link: '' }, xsb_nayong: { protocol: 'zjonlinenayong', link: '' }, xsb_fuquan: { protocol: 'zjonlinefuquan', link: '' } },
        _custom_params: {}
    };

    function timeout(callback, time) {
        var timer = null;
        if (typeof callback != 'function') { return timer; }
        timer = setTimeout(function () { callback(); }, time || 0);
        return timer;
    }
    var Driver = function (readycallback) {
        var appJSBridgeName = 'trsAppJSBridge';
        var drivers = {
            trsAppJSBridge: {
                driver_params: {},
                preloadfiles: [],
                check: function (callback) {
                    let topWindow = window.top;
                    try{
                        console.log(topWindow[appJSBridgeName]);
                    }catch(e){
                        console.log(e);
                        topWindow = window;
                    }
                    if (!window[appJSBridgeName]&&!topWindow[appJSBridgeName]) {
                        appJSBridgeName = 'appJSBridge';
                    }
                    if (!window[appJSBridgeName]&&!topWindow[appJSBridgeName]) {
                        return;
                    }
                    if(topWindow!==window){
                        window[appJSBridgeName] = topWindow[appJSBridgeName];
                    }
                    Core.register('get_client_info', function (data) { callback({ client_code: data.client_code, version: data.version, detail: data.detail }); }, true);
                    window[appJSBridgeName].cp_get_client_info({ _cp_event: '111' });
                },
                load: function (client_info, callback) { callback(client_info); },
                init: function (options, client_info) {
                    var driver_var = this;
                    driver_var['_options'] = options;
                    options.ready(client_info);
                },
                delegate: function (event, data, client_info) {
                    data = data ? data : '';
                    var _options = this._options;
                    switch (event) {
                        case 'show_login':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_show_login) == 'function') { window[appJSBridgeName].cp_show_login(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'show_login', true);
                                cloudplate.trigger('reset', '');
                            }
                            break;
                        case 'open_county_home_page':
                            if (typeof window[appJSBridgeName].cp_open_county_home_page == 'function') { window[appJSBridgeName].cp_open_county_home_page(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'open_county_home_page', true);
                                cloudplate.trigger('open_county_home_page', "");
                            }
                            break;
                        case 'is_login':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_is_login) == 'function') { window[appJSBridgeName].cp_is_login(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'is_login', true);
                                cloudplate.trigger('is_login', '');
                            }
                            break;
                        case 'get_unique_id':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_get_unique_id) == 'function') { window[appJSBridgeName].cp_get_unique_id(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'get_unique_id', true);
                                cloudplate.trigger('get_unique_id', '');
                            }
                            break;
                        case 'get_account_id':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_get_account_id) == 'function') { window[appJSBridgeName].cp_get_account_id(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'get_account_id', true);
                                cloudplate.trigger('get_account_id', '');
                            }
                            break;
                        case 'get_client_info':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_get_client_info) == 'function') { window[appJSBridgeName].cp_get_client_info(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'get_client_info', true);
                                cloudplate.trigger('get_client_info', '');
                            }
                            break;
                        case 'get_device_info':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_get_device_info) == 'function') { window[appJSBridgeName].cp_get_device_info(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'get_device_info', true);
                                cloudplate.trigger('get_device_info', '');
                            }
                            break;
                        case 'reset':
                            cloudplate.trigger('reset', '');
                            break;
                        case 'get_css_mode':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_get_css_mode) == 'function') { window[appJSBridgeName].cp_get_css_mode(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'get_css_mode', true);
                                cloudplate.trigger('mode_change', '');
                            }
                            break;
                        case 'show_share':
                            !data.title ? data.title = '分享给你' : '';
                            !data.shareTo ? data.shareTo = 'all' : '';
                            !data.shareSummary ? data.shareSummary = '分享给你' : '';
                            !data.id ? data.id = 0 : '';
                            !data.type ? data.type = 'share' : '';
                            !data.datatype ? data.datatype = 'link' : '';
                            !data.dataUrl ? data.dataUrl = 0 : '';
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_show_share) == 'function') { window[appJSBridgeName].cp_show_share(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'show_share', true);
                                cloudplate.trigger('get_share_result', '');
                            }
                            break;
                        case 'get_location_info':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_get_location_info) == 'function') { window[appJSBridgeName].cp_get_location_info(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'get_location_info', true);
                                cloudplate.trigger('address_change', '');
                            }
                            break;
                        case 'get_customer_info':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_get_customer_info) == 'function') { window[appJSBridgeName].cp_get_customer_info(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'get_customer_info', true);
                                cloudplate.trigger('get_customer_info', '');
                            }
                            break;
                        case 'get_download_info':
                            if (!_cp_config.download_url[client_info.client_code]) {
                                driverIncompatible(data, 'get_download_info', true);
                                cloudplate.trigger('get_download_info', '');
                                break;
                            }
                            cloudplate.trigger('get_download_info', { to_new_verison: function () { window.location.href = _cp_config.download_url[client_info.client_code]; }, alertinfo: '', downloadlink: _cp_config.download_url[client_info.client_code] });
                            break;
                        case 'get_ip':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_get_ip) == 'function') { window[appJSBridgeName].cp_get_ip(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'get_ip', true);
                                cloudplate.trigger('get_ip', '');
                            }
                            break;
                        case 'get_image':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_get_image) == 'function') { window[appJSBridgeName].cp_get_image(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'get_image', true);
                                cloudplate.trigger('get_image', '');
                            }
                            break;
                        case 'get_voice':
                            driverIncompatible(data, 'get_voice');
                            cloudplate.trigger('get_voice', '');
                            break;
                        case 'start_voice':
                            if (typeof window[appJSBridgeName].cp_start_voice == 'function') { window[appJSBridgeName].cp_start_voice(JSON.stringify({ 'id': data.id })); } else {
                                driverIncompatible(data, 'start_voice');
                                cloudplate.trigger('start_voice', '');
                            }
                            break;
                        case 'file_upload':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_fileUpload) == 'function') { window[appJSBridgeName].cp_fileUpload(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'file_upload', true);
                                cloudplate.trigger('file_upload', '');
                            }
                            break;
                        case 'stop_voice':
                            if (typeof window[appJSBridgeName].cp_stop_voice == 'function') { window[appJSBridgeName].cp_stop_voice(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'stop_voice');
                                cloudplate.trigger('stop_voice', '');
                            }
                            break;
                        case 'get_video':
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_get_video) == 'function') { window[appJSBridgeName].cp_get_video(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'get_video', true);
                                cloudplate.trigger('get_video', '');
                            }
                            break;
                        case 'get_scan_qr':
                            driverIncompatible(data, 'get_scan_qr');
                            cloudplate.trigger('get_scan_qr', '');
                            break;
                        case 'search_beacons':
                            driverIncompatible(data, 'search_beacons');
                            cloudplate.trigger('search_beacons', '');
                            break;
                        case 'shake':
                            driverIncompatible(data, 'shake');
                            cloudplate.trigger('shake', '');
                            break;
                        case 'close':
                            if (window[appJSBridgeName] && typeof window[appJSBridgeName].cp_close === 'function') { window[appJSBridgeName].cp_close(JSON.stringify(data)); } else if (window && typeof (window.close) == 'function') { window.close(); }
                            timeout(function () { driverIncompatible(data, 'close'); }, 500);
                            break;
                        case 'set_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('set_data', '');
                                break;
                            }
                            if (typeof data != 'string') { data = JSON.stringify(data); }
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_setdata) == 'function') { window[appJSBridgeName].cp_setdata(data); } else {
                                driverIncompatible(data, 'set_data', true);
                                cloudplate.trigger('set_data', '');
                            }
                            break;
                        case 'get_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('get_data', '');
                                break;
                            }
                            if (typeof data != 'string') { data = JSON.stringify(data); }
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_getdata) == 'function') { window[appJSBridgeName].cp_getdata(data); } else {
                                driverIncompatible(data, 'get_data', true);
                                cloudplate.trigger('get_data', '');
                            }
                            break;
                        case 'set_share':
                            if (!data || !(data && data.link)) {
                                Tools.setError({ code: 105, msg: 'set_share 参数不正确', data: data });
                                cloudplate.trigger('set_share', { success: '0' });
                                break;
                            }
                            if (typeof (window[appJSBridgeName]) == 'object' && typeof (window[appJSBridgeName].cp_setshareinfo) == 'function') { window[appJSBridgeName].cp_setshareinfo(JSON.stringify(data)); } else if (client_info && client_info.version) {
                                if (/5\.[2-9]\.+/.test(client_info.version)) {
                                    window[appJSBridgeName + '_msg_title'] = !data.title ? '' : data.title;
                                    window[appJSBridgeName + '_msg_desc'] = !data.shareSummary ? '' : data.shareSummary;
                                    window[appJSBridgeName + '_msg_cdn_url'] = !data.imgUrl ? '' : data.imgUrl;
                                    window[appJSBridgeName + '_msg_link'] = data.link;
                                } else if (/5\.[0-9]\.+/.test(client_info.version)) {
                                    window[appJSBridgeName + '_title'] = !data.title ? '' : data.title;
                                    window[appJSBridge + '_desc'] = !data.shareSummary ? '' : data.shareSummary;
                                    window[appJSBridge + '_cdn_url'] = !data.imgUrl ? '' : data.imgUrl;
                                    window[appJSBridge + '_link'] = data.link;
                                }
                                cloudplate.trigger('set_share', { success: '1' });
                            } else {
                                driverIncompatible(data, 'set_share', true);
                                cloudplate.trigger('set_share', { success: '0' });
                            }
                            break;
                        case 'play_voice':
                            break;
                        case 'pause_play_voice':
                            break;
                        case 'stop_play_voice':
                            break;
                        case 'url_redirect':
                            window.location.href = data.url;
                            break;
                        case 'bindmobile':
                            if (typeof window[appJSBridgeName].cp_bindmobile == 'function') { window[appJSBridgeName].cp_bindmobile(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'bindmobile');
                                cloudplate.trigger('bindmobile', '');
                            }
                            break;
                        case 'is_bindmobile':
                            if (typeof window[appJSBridgeName].cp_isbindmobile == 'function') { window[appJSBridgeName].cp_isbindmobile(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'is_bindmobile');
                                cloudplate.trigger('is_bindmobile', '');
                            }
                            break;
                        case 'show_modify_mobile':
                            if (typeof window[appJSBridgeName].cp_modify_mobile == 'function') { window[appJSBridgeName].cp_modify_mobile(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'modify_mobile');
                                cloudplate.trigger('modify_mobile', { success: '0' });
                            }
                            break;
                        case 'define_menu':
                            if (typeof window[appJSBridgeName].cp_define_menu == 'function') { window[appJSBridgeName].cp_define_menu(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'define_menu');
                                cloudplate.trigger('define_menu', { success: '0' });
                            }
                            break;
                        case 'select_media':
                            if (typeof window[appJSBridgeName].cp_select_media == 'function') { window[appJSBridgeName].cp_select_media(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'select_media');
                                cloudplate.trigger('select_media', { success: '0' });
                            }
                            break;
                        case 'subscribe_event':
                            if (typeof window[appJSBridgeName].cp_subscribe_event == 'function') { window[appJSBridgeName].cp_subscribe_event(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'subscribe_event');
                                cloudplate.trigger('subscribe_event', { success: '0' });
                            }
                            break;
                        case 'preview':
                            if (typeof window[appJSBridgeName].cp_preview == 'function') { window[appJSBridgeName].cp_preview(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'preview');
                                cloudplate.trigger('preview', { success: '0' });
                            }
                            break;
                        case 'pay_for_reading':
                            if (typeof window[appJSBridgeName].cp_pay_for_reading == 'function') { window[appJSBridgeName].cp_pay_for_reading(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'pay_for_reading');
                                cloudplate.trigger('pay_for_reading', { success: '0' });
                            }
                            break;
                        case 'set_top_bar':
                            if (typeof window[appJSBridgeName].cp_set_top_bar == 'function') { window[appJSBridgeName].cp_set_top_bar(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'set_top_bar');
                                cloudplate.trigger('set_top_bar', { success: '0' });
                            }
                            break;
                        case 'open_new_page':
                            if (typeof window[appJSBridgeName].cp_open_new_page == 'function') { window[appJSBridgeName].cp_open_new_page(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'open_new_page');
                                cloudplate.trigger('open_new_page', { success: '0' });
                            }
                            break;
                        case 'emit':
                            if (typeof window[appJSBridgeName].cp_emit == 'function') { window[appJSBridgeName].cp_emit(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'emit');
                                cloudplate.trigger('emit', { success: '0' });
                            }
                            break;
                        case 'open_launch_weapp':
                            if (typeof window[appJSBridgeName].cp_open_launch_weapp == 'function') { window[appJSBridgeName].cp_open_launch_weapp(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'open_launch_weapp');
                                cloudplate.trigger('open_launch_weapp', { success: '0' });
                            }
                            break;
                        case 'download_file':
                            if (typeof window[appJSBridgeName].cp_download_file == 'function') { window[appJSBridgeName].cp_download_file(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'download_file', true);
                                cloudplate.trigger('download_file', { success: '0' });
                            }
                            break;
                        case 'open_hoo_app':
                            if (typeof window[appJSBridgeName].cp_open_hoo_app == 'function') { window[appJSBridgeName].cp_open_hoo_app(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'open_hoo_app', true);
                                cloudplate.trigger('open_hoo_app', { success: '0' });
                            }
                            break;
                        case 'go_homepage':
                            if (typeof window[appJSBridgeName].cp_go_homepage == 'function') { window[appJSBridgeName].cp_go_homepage(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'go_homepage', true);
                                cloudplate.trigger('go_homepage', { success: '0' });
                            }
                            break;
                        case 'change_status_style':
                            if (typeof window[appJSBridgeName].cp_change_status_style == 'function') { window[appJSBridgeName].cp_change_status_style(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'change_status_style', true);
                                cloudplate.trigger('change_status_style', { success: '0' });
                            }
                            break;
                        case 'show_dy_mode_videos':
                            if (typeof window[appJSBridgeName].cp_show_dy_mode_videos == 'function') { window[appJSBridgeName].cp_show_dy_mode_videos(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'show_dy_mode_videos', true);
                                cloudplate.trigger('show_dy_mode_videos', { success: '0' });
                            }
                            break;
                        case 'play_audio':
                            if (typeof window[appJSBridgeName].cp_play_audio == 'function') { window[appJSBridgeName].cp_play_audio(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'play_audio', true);
                                cloudplate.trigger('play_audio', { success: '0' });
                            }
                            break;
                        case 'pause_audio':
                            if (typeof window[appJSBridgeName].cp_pause_audio == 'function') { window[appJSBridgeName].cp_pause_audio(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'pause_audio', true);
                                cloudplate.trigger('pause_audio', { success: '0' });
                            }
                            break;
                        case 'query_audio':
                            if (typeof window[appJSBridgeName].cp_query_audio == 'function') { window[appJSBridgeName].cp_query_audio(JSON.stringify(data)); } else {
                                driverIncompatible(data, 'query_audio', true);
                                cloudplate.trigger('query_audio', { success: '0' });
                            }
                            break;
                        default:
                            driverIncompatible(data, event);
                            cloudplate.trigger(event, '');
                            break;
                    }
                }
            },
            wx: {
                driver_params: {},
                preloadfiles: [window.location.protocol + '//res2.wx.qq.com/open/js/jweixin-1.6.0.js'],
                check: function (callback) { if (Tools.browser(true) == 'wx') { callback({ client_code: 'wx', version: '0', detail: '' }); }; },
                load: function (driver_params, callback) { Request._loadResource(this.preloadfiles, function () { callback(driver_params); }); },
                init: function (options, client_info) {
                    if (!options.wxOption || !options.wxOption.siteId || !options.wxOption.tenantId) {
                        Tools.writelog('模式：', '未获取到siteId或tenantId,无法查询signature');
                        options.ready(client_info);
                        return;
                    }
                    var driver_var = this;
                    driver_var['_options'] = options.wxOption;
                    Core.register('sys_jsonp', function (data) {
                        Request._is_jsonp_called = true;
                        if (!data || typeof data !== 'object') {
                            alert('获取微信签名失败（AUTH FAIL）');
                            Tools.setError({ code: 104, msg: '获取微信签名失败（AUTH FAIL）', data: data });
                            return;
                        }
                        if (data && data.hasOwnProperty('code') && data.code != 0 || !wx || !wx.hasOwnProperty('config')) {
                            Tools.setError({ code: 104, msg: '微信初始化对象失败', data: data });
                            options.ready(client_info);
                            return;
                        }
                        if (!options.wxOption || !data.appId || !data.signature || !data.nonceStr || !data.timestamp) {
                            alert('微信配置不全');
                            Tools.setError({ code: 104, msg: '微信配置不全', data: data });
                            return;
                        }
                        var wx_run = false;
                        wx && wx.error(function (res) {
                            if (res && res.errMsg == 'config:invalid url domain') { res.errCode = 1002; }
                            Tools.setError(res);
                        });
                        wx && wx.ready(function () {
                            wx_run = true;
                            options.ready(client_info);
                            wx.checkJsApi && wx.checkJsApi({
                                jsApiList: ['updateTimelineShareData', Tools.checkIsInWechatPCBrowser() ? 'onMenuShareAppMessage' : 'updateAppMessageShareData', 'onMenuShareQQ', 'onMenuShareQZone'],
                                success: function (res) {
                                    _cp_config._custom_params['checkResult'] = res.checkResult;
                                }
                            });
                        });
                        wx && wx.config({ debug: options.wxOption.debug, appId: data.appId, timestamp: data.timestamp, nonceStr: data.nonceStr, signature: data.signature, jsApiList: options.wxOption.jsApiList, openTagList: options.wxOption.openTagList });
                        timeout(function () { if (!wx_run) { wx && wx.config({ debug: options.wxOption.debug, appId: data.appId, timestamp: data.timestamp, nonceStr: data.nonceStr, signature: data.signature, jsApiList: options.wxOption.jsApiList, openTagList: options.wxOption.openTagList }); } }, 2000);
                    }, true, 8000);
                    var params = { 'url': encodeURIComponent(options.wxOption.redirect), 'siteCode': options.wxOption.siteId, 'tenantCode': options.wxOption.tenantId, 'callbackName': 'CP._jsonpCallback' };
                    Tools.ajax({
                        url: _cp_config.wx_api_urls[options.wxOption.tenantId + "_" + options.wxOption.siteId],
                        type: 'GET',
                        data: params,
                        dataType: 'jsonp',
                        success: function (data) { },
                        fail: function (data) {
                            if (typeof (options.error) != 'function') { alert('微信获取签名失败，请检查重试'); }
                            var code = 1;
                            if (data && data.hasOwnProperty('code')) { code = data.code; }
                            Tools.setError({ code: code, msg: '微信获取签名失败', data: data });
                        }
                    });
                },
                delegate: function (event, data, client_info) {
                    var driver_temp = this;
                    var _options = this._options;
                    data = data ? data : '';
                    switch (event) {
                        case 'show_login':
                            driverIncompatible(data, 'show_login');
                            cloudplate.trigger('show_login', '');
                            break;
                        case 'is_login':
                            driverIncompatible(data, 'is_login');
                            cloudplate.trigger('is_login', '');
                            break;
                        case 'get_unique_id':
                            driverIncompatible(data, 'get_unique_id');
                            cloudplate.trigger('get_unique_id', '');
                            break;
                        case 'get_account_id':
                            driverIncompatible(data, 'get_account_id');
                            cloudplate.trigger('get_account_id', '');
                            break;
                        case 'get_client_info':
                            cloudplate.trigger('get_client_info', { client_code: 'wx', version: '1.0', detail: '' });
                            break;
                        case 'get_device_info':
                            driverIncompatible(data, 'get_device_info');
                            cloudplate.trigger('get_device_info', '');
                            break;
                        case 'reset':
                            cloudplate.trigger('reset', '');
                            break;
                        case 'get_css_mode':
                            driverIncompatible(data, 'get_css_mode');
                            cloudplate.trigger('get_css_mode', '');
                            break;
                        case 'show_share':
                            driverIncompatible(data, 'show_share');
                            cloudplate.trigger('show_share', '');
                            break;
                        case 'get_location_info':
                            wx && wx.getLocation({
                                type: 'wgs84',
                                success: function (res) {
                                    var result = {};
                                    result['lat'] = res.latitude;
                                    result['lon'] = res.longitude;
                                    result['radius'] = '';
                                    result['city'] = '';
                                    result['addr'] = '';
                                    result['speed'] = res.speed;
                                    result['accuracy'] = res.accuracy;
                                    cloudplate.trigger('address_change', result);
                                }
                            });
                            break;
                        case 'get_customer_info':
                            driverIncompatible(data, 'get_customer_info');
                            cloudplate.trigger('get_customer_info', '');
                            break;
                        case 'get_download_info':
                            cloudplate.trigger('get_download_info', { to_new_verison: function () { window.location.href = _cp_config.download_url.wx; } });
                            break;
                        case 'get_ip':
                            driverIncompatible(data, 'get_ip');
                            cloudplate.trigger('get_ip', '');
                            break;
                        case 'get_image':
                            var count = data.count && data.count > 0 && data.count < 10 ? data.count : 1;
                            wx && wx.chooseImage({
                                count: count,
                                sizeType: ['original', 'compressed'],
                                sourceType: ['album', 'camera'],
                                success: function (res) {
                                    Tools.writelog('get_image res', res);
                                    var result = { address: res.localIds, id: data.id, sizeType: 'original', sourceType: res.sourceType, count: count, dataType: 'addr', data: [] };
                                    cloudplate.trigger('get_image', result);
                                },
                                fail: function (res) {
                                    Tools.writelog('chooseImage-fail', res);
                                    alert(JSON.stringify(res));
                                }
                            });
                            break;
                        case 'get_voice':
                            driverIncompatible(data, 'get_voice');
                            cloudplate.trigger('get_voice', '');
                            break;
                        case 'start_voice':
                            wx && wx.onVoiceRecordEnd({
                                complete: function (res) {
                                    Tools.writelog('onVoiceRecordEnd', res);
                                    var result = { id: data.id, address: res.localId };
                                    cloudplate.trigger('stop_voice', result);
                                }
                            });
                            var result = { id: data.id, address: '', info: '' };
                            Tools.writelog('startRecord ');
                            wx && wx.startRecord({
                                complete: function (res) { cloudplate.trigger('start_voice', result); },
                                cancel: function (res) {
                                    result.info = res;
                                    cloudplate.trigger('stop_voice', res);
                                    Tools.writelog('wx startRecord cancel');
                                }
                            });
                            break;
                        case 'file_upload':
                            var result = { requestcode: 200, 'return': {}, info: '' };
                            var upload_urls = [];
                            if (typeof (data.localfile) == 'object') { upload_urls = data.localfile; } else if (typeof (data.localfile) == 'string') { upload_urls = [data.localfile]; }
                            if (data.type) {
                                if (data.type == 'voice') {
                                    wx && wx.uploadVoice({
                                        localId: upload_urls.toString(),
                                        isShowProgressTips: 1,
                                        success: function (res) {
                                            Tools.writelog('data type', res);
                                            res.wx_appid = driver_temp._options.appid;
                                            res.filename = data.filename;
                                            Tools.ajax({
                                                url: data.serviceurl,
                                                type: 'post',
                                                data: res,
                                                dataType: "json",
                                                success: function (data) {
                                                    Tools.writelog('Tools data type', data);
                                                    result.requestcode = 0;
                                                    result.data = data;
                                                    result.return = JSON.stringify(data);
                                                    cloudplate.trigger('file_upload', result);
                                                },
                                                fail: function (error, code) {
                                                    Tools.writelog('Tools data type error', data);
                                                    result.requestcode = 400;
                                                    result.data = error;
                                                    Tools.setError({ code: 1001, msg: '上传音频失败', data: { 'code': code, 'error': error } });
                                                    cloudplate.trigger('file_upload', result);
                                                }
                                            });
                                        }
                                    });
                                } else if (data.type == 'image') {
                                    wx && wx.uploadImage({
                                        localId: upload_urls.toString(),
                                        isShowProgressTips: 1,
                                        success: function (res) {
                                            res.wx_appid = driver_temp._options.appid;
                                            Tools.ajax({
                                                url: data.serviceurl,
                                                type: 'post',
                                                data: res,
                                                dataType: "json",
                                                success: function (data) {
                                                    result.requestcode = 0;
                                                    result.data = data;
                                                    cloudplate.trigger('file_upload', result);
                                                },
                                                fail: function (data, code) {
                                                    result.requestcode = 400;
                                                    result.data = data;
                                                    cloudplate.trigger('file_upload', result);
                                                }
                                            });
                                        },
                                        fail: function (res) { result.requestcode = 401, result.data = res, cloudplate.trigger('file_upload', result); }
                                    });
                                } else {
                                    Tools.ajax({
                                        url: data.serviceurl,
                                        type: 'post',
                                        data: data,
                                        dataType: "json",
                                        success: function (data) { result.requestcode = 200, result.data = data, cloudplate.trigger('file_upload', result); },
                                        fail: function (error, code) {
                                            result.requestcode = 400;
                                            result.data = error;
                                            Tools.setError({ code: 1001, msg: '上传数据失败', data: { 'code': code, 'error': error } });
                                            cloudplate.trigger('file_upload', result);
                                        }
                                    });
                                }
                            }
                            break;
                        case 'stop_voice':
                            wx && wx.stopRecord({
                                success: function (res) {
                                    var result = { id: data.id, address: res.localId };
                                    Core.trigger('stop_voice', result);
                                },
                                fail: function (res) { Tools.writelog('wx stopRecord fail', res); }
                            });
                            break;
                        case 'get_video':
                            driverIncompatible(data, 'get_video');
                            cloudplate.trigger('get_video', '');
                            break;
                        case 'get_scan_qr':
                            wx && wx.scanQRCode({ desc: 'scanQRCode desc', needResult: 0, scanType: ["qrCode", "barCode"], success: function (res) { }, error: function (res) { if (res.errMsg.indexOf('function_not_exist') > 0) { alert('版本过低请升级') } } });
                            break;
                        case 'search_beacons':
                            driverIncompatible(data, 'search_beacons');
                            cloudplate.trigger('search_beacons', '');
                            break;
                        case 'shake':
                            driverIncompatible(data, 'shake');
                            cloudplate.trigger('shake', '');
                            break;
                        case 'close':
                            wx && wx.closeWindow();
                            break;
                        case 'set_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('set_data', '');
                                break;
                            }
                            window.localStorage && window.localStorage.setItem(data.key, data.value);
                            window.sessionStorage && window.sessionStorage.setItem(data.key, data.value);
                            var result = '';
                            if (window.localStorage || window.sessionStorage) { result = { success: true }; } else { result = { success: false }; }
                            cloudplate.trigger('set_data', result);
                            break;
                        case 'get_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('get_data', '');
                                break;
                            }
                            var result = '';
                            window.localStorage ? result = window.localStorage.getItem(data.key) : '';
                            window.sessionStorage && result === '' ? result = window.sessionStorage.getItem(data.key) : '';
                            if (window.localStorage || window.sessionStorage) { result = { success: true, data: result }; } else { result = { success: false, data: result }; }
                            cloudplate.trigger('get_data', result);
                            break;
                        case 'open_new_page':
                            window.open(data.url)
                            cloudplate.trigger('open_new_page', '打开页面：“' + data.url + '”执行完成');
                            break;
                        case 'set_share':
                            var checkResult = _cp_config._custom_params['checkResult'];
                            data['shareTo'] = data.shareTo ? data.shareTo : 'all';

                            function setShare(to, callback, success_callback) {
                                success_callback = success_callback || function () { };
                                if (to == 'Timeline') {
                                    wx && (!checkResult || checkResult.updateTimelineShareData) && wx.updateTimelineShareData({ title: data.title, link: data.link, imgUrl: data.imgUrl, complete: function (res) { callback(res, 'Timeline'); }, success: function (res) { success_callback(res, 'Timeline'); } });
                                    wx && checkResult && !checkResult.updateTimelineShareData && wx.updateTimelineShareData({ title: data.title, link: data.link, imgUrl: data.imgUrl, complete: function (res) { callback(res, 'Timeline'); }, success: function (res) { success_callback(res, 'Timeline'); } });
                                } else if (to == 'AppMessage') { wx && (!checkResult || checkResult[Tools.checkIsInWechatPCBrowser() ? 'onMenuShareAppMessage' : 'updateAppMessageShareData']) && wx[Tools.checkIsInWechatPCBrowser() ? 'onMenuShareAppMessage' : 'updateAppMessageShareData'] && wx[Tools.checkIsInWechatPCBrowser() ? 'onMenuShareAppMessage' : 'updateAppMessageShareData']({ title: data.title, desc: data.shareSummary, link: data.link, imgUrl: data.imgUrl, type: data.datatype, dataUrl: data.dataUrl, complete: function (res) { callback(res, 'AppMessage'); }, success: function (res) { success_callback(res, 'AppMessage'); } }); } else if (to == 'ShareQQ') {
                                    wx && checkResult && !checkResult.onMenuShareQQ && wx[Tools.checkIsInWechatPCBrowser() ? 'onMenuShareAppMessage' : 'updateAppMessageShareData'] && wx[Tools.checkIsInWechatPCBrowser() ? 'onMenuShareAppMessage' : 'updateAppMessageShareData']({ title: data.title, desc: data.shareSummary, link: data.link, imgUrl: data.imgUrl, complete: function (res) { callback(res, 'ShareQQ'); }, success: function (res) { success_callback(res, 'ShareQQ'); } });
                                    wx && (!checkResult || checkResult.onMenuShareQQ) && wx.onMenuShareQQ && wx.onMenuShareQQ({ title: data.title, desc: data.shareSummary, link: data.link, imgUrl: data.imgUrl, complete: function (res) { callback(res, 'ShareQQ'); }, success: function (res) { success_callback(res, 'ShareQQ'); } });
                                } else if (to == 'WeiBo') { wx && wx.onMenuShareWeibo({ title: data.title, desc: data.shareSummary, link: data.link, imgUrl: data.imgUrl, complete: function (res) { callback(res, 'WeiBo'); }, success: function (res) { success_callback(res, 'WeiBo'); } }); } else if (to == 'QQZone') { wx && (!checkResult || checkResult.onMenuShareQZone) && wx.onMenuShareQZone({ title: data.title, desc: data.shareSummary, link: data.link, imgUrl: data.imgUrl, complete: function (res) { callback(res, 'QQZone'); }, success: function (res) { success_callback(res, 'WeiBo'); } }); }
                            }
                            var result = { 'result': 'success', 'shareTo': data.shareTo, 'allow_alert': '0', };
                            var share_callback = function (res, channel) {
                                if (res.errMsg && res.errMsg.indexOf(':ok') !== false) { result.result = 'success'; } else { result.result = 'fail'; }
                                cloudplate.trigger('set_share', result);
                            };
                            var share_success_callback = function (res, channel) {
                                if (res.errMsg && res.errMsg.indexOf(':ok') !== false) { result.result = 'success'; } else { result.result = 'fail'; }
                                cloudplate.trigger('set_share_success', result);
                            };
                            if (data.shareTo === 'all') {
                                setShare('Timeline', share_callback, share_success_callback);
                                setShare('AppMessage', share_callback, share_success_callback);
                                setShare('WeiBo', share_callback, share_success_callback);
                                setShare('ShareQQ', share_callback, share_success_callback);
                                setShare('QQZone', share_callback, share_success_callback);
                            } else { setShare(data.shareTo, share_callback, share_success_callback); }
                            break;
                        case 'play_voice':
                            var eleId = '';
                            if (data['eleId']) { eleId = data['eleId']; }
                            if (typeof (data.address) == 'string' && /^weixin:\/\/resourceid\/.+$/gi.test(data.address)) { wx && wx.playVoice({ localId: data.address }); return true; }
                            if (!typeof (data.address) == 'string' || !/^(http|https):\/\/$/gi.test(data.address)) { return false; }
                            if (!data['eleId']) { eleId = Tools.createAudioElement(); }
                            var audio = document.getElementById(eleId);
                            audio.src = data['address'];
                            audio.play();
                            if (data['onPlayEnd'] != undefined) {
                                var is_playFinish = setInterval(function () {
                                    if (audio.ended) {
                                        data['onPlayEnd']({ 'eleId': eleId });
                                        window.clearInterval(is_playFinish);
                                    }
                                }, 10);
                            }
                            cloudplate.trigger('play_voice', { 'eleId': eleId });
                            return eleId;
                            break;
                        case 'pause_play_voice':
                            wx && wx.pauseVoice({ localId: data.address });
                            cloudplate.trigger('pause_play_voice', { 'eleId': '' });
                            break
                        case 'stop_play_voice':
                            wx && wx.stopVoice({ localId: data.address });
                            cloudplate.trigger('stop_play_voice', { 'eleId': '' });
                            break;
                        case 'url_redirect':
                            window.location.href = data.url;
                            break;
                        case 'bindmobile':
                            driverIncompatible(data, 'bindmobile');
                            cloudplate.trigger('bindmobile', '');
                            break;
                        case 'is_bindmobile':
                            driverIncompatible(data, 'is_bindmobile');
                            cloudplate.trigger('is_bindmobile', '');
                            break;
                        case 'redpacket_open_success':
                            driverIncompatible(data, 'redpacket_open_success');
                            cloudplate.trigger('redpacket_open_success', { success: '1' });
                            break;
                        case 'show_modify_mobile':
                            driverIncompatible(data, 'modify_mobile');
                            cloudplate.trigger('modify_mobile', { success: '0' });
                            break;
                        case 'open_in_app':
                            if (!data.defaultClient) { cloudplate.trigger('open_in_app', { success: '0' }); }
                            if (data.defaultClient && data.defaultClient.client_code) { Tools.callInApp(data, client_info.client_code); } else {
                                driverIncompatible(data, 'open_in_app');
                                cloudplate.trigger('open_in_app', { success: '0' });
                            }
                            break;
                        case 'check_wx_js_api':
                            var result = { success: '0', data: '' };
                            wx && wx.checkJsApi({
                                jsApiList: data.jsApiList,
                                success: function (res) {
                                    result.success = '1';
                                    result.data = res;
                                    cloudplate.trigger('check_wx_js_api', result);
                                },
                                cancel: function (res) {
                                    result.success = '0';
                                    result.data = res;
                                    cloudplate.trigger('check_wx_js_api', result);
                                },
                                fail: function (res) {
                                    result.success = '0';
                                    cloudplate.trigger('check_wx_js_api', result);
                                }
                            });
                            break;
                        case 'preview':
                            if (data.imageList && data.imageList.length > data.target) { wx && wx.previewImage({ current: data.imageList[data.target], urls: data.imageList }); }
                            cloudplate.trigger('preview', { success: '1' });
                            break;
                        case 'download_image':
                            wx && wx.downloadImage({ serverId: data.serverId, isShowProgressTips: data.isShowProgressTips, success: function (res) { cloudplate.trigger('download_image', { success: '1', data: res }); }, cancel: function (res) { cloudplate.trigger('download_image', { success: '0', data: res }); }, fail: function (res) { cloudplate.trigger('download_image', { success: '0', data: res }); } });
                            break;
                        case 'get_local_img_data':
                            wx && wx.getLocalImgData({ localId: data.localId, success: function (res) { cloudplate.trigger('get_local_img_data', { success: '1', data: res }); }, cancel: function (res) { cloudplate.trigger('get_local_img_data', { success: '0', data: res }); }, fail: function (res) { cloudplate.trigger('get_local_img_data', { success: '0', data: res }); } });
                            break;
                        case 'download_voice':
                            wx && wx.downloadVoice({
                                serverId: data.serverId,
                                isShowProgressTips: data.isShowProgressTips,
                                success: function (res) {
                                    var localId = res.localId;
                                    cloudplate.trigger('download_voice', { success: '1', data: res });
                                },
                                cancel: function (res) { cloudplate.trigger('download_voice', { success: '0', data: res }); },
                                fail: function (res) { cloudplate.trigger('download_voice', { success: '0', data: res }); }
                            });
                            break;
                        case 'translate_voice':
                            wx && wx.translateVoice({ localId: data.localId, isShowProgressTips: data.isShowProgressTips, success: function (res) { cloudplate.trigger('translate_voice', { success: '1', data: res }); }, cancel: function (res) { cloudplate.trigger('translate_voice', { success: '0', data: res }); }, fail: function (res) { cloudplate.trigger('translate_voice', { success: '0', data: res }); } });
                            break;
                        case 'get_network_type':
                            wx && wx.getNetworkType({
                                success: function (res) {
                                    var networkType = res.networkType;
                                    cloudplate.trigger('get_network_type', { success: '1', data: res });
                                },
                                cancel: function (res) { cloudplate.trigger('get_network_type', { success: '0', data: res }); },
                                fail: function (res) { cloudplate.trigger('get_network_type', { success: '0', data: res }); }
                            });
                            break;
                        case 'open_location':
                            wx && wx.openLocation({ latitude: data.latitude, longitude: data.longitude, name: data.name, address: data.address, scale: data.scale, infoUrl: data.infoUrl });
                            cloudplate.trigger('open_location', { success: '1' });
                            break;
                        case 'start_search_beacons':
                            wx && wx.startSearchBeacons({ ticket: data.ticket, complete: function (argv) { cloudplate.trigger('start_search_beacons', { success: '1', data: argv }); } });
                            break;
                        case 'stop_search_beacons':
                            wx && wx.stopSearchBeacons({ complete: function (res) { cloudplate.trigger('stop_search_beacons', { success: '1', data: res }); } });
                            break;
                        case 'on_search_beacons':
                            wx && wx.onSearchBeacons({ complete: function (argv) { cloudplate.trigger('on_search_beacons', { success: '1', data: argv }); } });
                            break;
                        case 'hide_menu_items':
                            wx && wx.hideMenuItems({ menuList: data.menuList });
                            cloudplate.trigger('hide_menu_items', { success: '1' });
                            break;
                        case 'show_menu_items':
                            wx && wx.showMenuItems({ menuList: data.menuList });
                            cloudplate.trigger('show_menu_items', { success: '1' });
                            break;
                        case 'hide_all_non_base_menu_item':
                            wx && wx.hideAllNonBaseMenuItem();
                            cloudplate.trigger('hide_all_non_base_menu_item', { success: '1' });
                            break;
                        case 'show_all_non_base_menu_item':
                            wx && wx.showAllNonBaseMenuItem();
                            cloudplate.trigger('show_all_non_base_menu_item', { success: '1' });
                            break;
                        case 'open_product_specific_view':
                            wx && wx.openProductSpecificView({ productId: data.productId, viewType: data.viewType });
                            cloudplate.trigger('open_product_specific_view', { success: '1' });
                            break;
                        case 'choose_card':
                            wx && wx.chooseCard({
                                shopId: data.shopId,
                                cardType: data.cardType,
                                cardId: data.cardId,
                                timestamp: data.timestamp,
                                nonceStr: data.nonceStr,
                                signType: data.signType,
                                cardSign: data.cardSign,
                                success: function (res) {
                                    var cardList = res.cardList;
                                    cloudplate.trigger('choose_card', { success: '1', data: res });
                                },
                                cancel: function (res) { cloudplate.trigger('choose_card', { success: '0', data: res }); },
                                fail: function (res) { cloudplate.trigger('choose_card', { success: '0', data: res }); }
                            });
                            break;
                        case 'add_card':
                            wx && wx.addCard({
                                cardList: data.cardList,
                                success: function (res) {
                                    var cardList = res.cardList;
                                    cloudplate.trigger('add_card', { success: '1', data: res });
                                },
                                cancel: function (res) { cloudplate.trigger('add_card', { success: '0', data: res }); },
                                fail: function (res) { cloudplate.trigger('add_card', { success: '0', data: res }); }
                            });
                            break;
                        case 'open_card':
                            wx && wx.openCard({ cardList: data.cardList, });
                            cloudplate.trigger('open_card', { success: '1' });
                            break;
                        case 'choose_wx_pay':
                            wx && wx.chooseWXPay({ timestamp: data.timestamp, nonceStr: data.nonceStr, package: data.package, signType: data.signType, paySign: data.paySign, success: function (res) { cloudplate.trigger('choose_wx_pay', { success: '1', data: res }); }, cancel: function (res) { cloudplate.trigger('choose_wx_pay', { success: '0', data: res }); }, fail: function (res) { cloudplate.trigger('choose_wx_pay', { success: '0', data: res }); } });
                            break;
                        case 'open_address':
                            wx && wx.openAddress({ success: function (res) { cloudplate.trigger('open_address', { success: '1', data: res }); }, cancel: function (res) { cloudplate.trigger('open_address', { success: '0', data: res }); }, fail: function (res) { cloudplate.trigger('open_address', { success: '0', data: res }); } });
                            break;
                        case 'open_county_home_page':
                            window.location.href = data.url;
                            break;
                        default:
                            driverIncompatible(data, event);
                            cloudplate.trigger(event, '');
                            break;
                    }
                }
            },
            qq: {
                driver_params: {},
                preloadfiles: ['https://qzonestyle.gtimg.cn/qzone/qzact/common/share/share.js'],
                check: function (callback) { if (Tools.browser() == 'qq') { callback({ client_code: 'qq', version: '', detail: '' }); } },
                load: function (client_info, callback) { Request._loadResource(this.preloadfiles, function () { callback(client_info); }); },
                init: function (options, client_info) {
                    var driver_var = this;
                    driver_var['_options'] = options;
                    options.ready(client_info);
                },
                delegate: function (event, data, client_info) {
                    var _options = this._options;
                    data = data ? data : '';
                    switch (event) {
                        case 'get_client_info':
                            cloudplate.trigger('get_client_info', { client_code: 'qq', version: 'X', detail: '' });
                            break;
                        case 'close':
                            if (window && typeof (window.close) == 'function') { window.close(); } else { driverIncompatible(data, 'close'); }
                            break;
                        case 'set_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('set_data', '');
                                break;
                            }
                            window.localStorage && window.localStorage.setItem(data.key, data.value);
                            window.sessionStorage && window.sessionStorage.setItem(data.key, data.value);
                            var result = '';
                            if (window.localStorage || window.sessionStorage) { result = { success: true }; } else { result = { success: false }; }
                            cloudplate.trigger('set_data', result);
                            break;
                        case 'get_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('get_data', '');
                                break;
                            }
                            var result = '';
                            window.localStorage ? result = window.localStorage.getItem(data.key) : '';
                            window.sessionStorage && result === '' ? result = window.sessionStorage.getItem(data.key) : '';
                            if (window.localStorage || window.sessionStorage) { result = { success: true, data: result }; } else { result = { success: false, data: result }; }
                            cloudplate.trigger('get_data', result);
                            break;
                        case 'set_share':
                            !data.title ? data.title = '分享给你' : '';
                            !data.shareSummary ? data.shareSummary = '分享给你' : '';
                            !data.imgUrl ? data.imgUrl = '' : '';
                            if (window.mqq) {
                                window.mqq.invoke("data", "setShareInfo", { share_url: data.link, title: data.title, desc: data.shareSummary, image_url: data.imgUrl });
                                cloudplate.trigger('set_share', { success: true });
                            } else { cloudplate.trigger('set_share', { success: false }); }
                            break;
                        case 'open_new_page':
                            window.open(data.url)
                            cloudplate.trigger('open_new_page', '打开页面：“' + data.url + '”执行完成');
                            break;
                        case 'url_redirect':
                            window.location.href = data.url;
                            break;
                        case 'open_in_app':
                            if (!data.defaultClient) { cloudplate.trigger('open_in_app', { success: '0' }); }
                            if (data.defaultClient && data.defaultClient.client_code) { Tools.callInApp(data, client_info.client_code); } else {
                                driverIncompatible(data, 'open_in_app');
                                cloudplate.trigger('open_in_app', { success: '0' });
                            }
                            break;
                        case 'open_county_home_page':
                            window.location.href = data.url;
                            break;
                        default:
                            driverIncompatible(data, event);
                            cloudplate.trigger(event, '');
                            break;
                    }
                }
            },
            dd: {
                driver_params: {},
                preloadfiles: [_cp_config.dd_api_url],
                check: function (callback) {
                    if (Tools.browser() == 'dd') {
                        driverIsLoading = true;
                        var v = navigator.userAgent.toLowerCase();
                        var dversion = v.match(/aliapp\(\w+\/([a-zA-Z0-9.-]+)\)/);
                        null === dversion && (dversion = v.match(/dingtalk\/([a-zA-Z0-9.-]+)/));
                        callback({
                            client_code: 'dd',
                            version: dversion && dversion[1],
                            detail: '',
                            is_client: '1'
                        });
                    }
                },
                load: function (client_info, callback) {
                    Request._loadResource(this.preloadfiles, function () {
                        callback(client_info);
                    });
                },
                init: function (options, client_info) {
                    var driver_var = this;
                    driver_var['_options'] = options;
                    driver_var.driver_params['set_share'] = function () { };
                    dd && dd.ready(function () {
                        options.ready(client_info);
                    });
                },
                filterUrl: function (url) {
                    return url;
                },
                delegate: function (event, data, client_info) {
                    var _options = this._options;
                    data = data ? data : '';
                    switch (event) {
                        case 'get_client_info':
                            cloudplate.trigger('get_client_info', client_info);
                            break;
                        case 'close':
                            if (window && typeof (window.close) == 'function') {
                                window.close();
                            } else {
                                driverIncompatible(data, 'close');
                            }
                            break;
                        case 'set_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({
                                    code: 105,
                                    msg: '参数传值不对',
                                    data: ''
                                });
                                cloudplate.trigger('set_data', '');
                                break;
                            }
                            window.localStorage && window.localStorage.setItem(data.key, data.value);
                            window.sessionStorage && window.sessionStorage.setItem(data.key, data.value);
                            var result = '';
                            if (window.localStorage || window.sessionStorage) {
                                result = {
                                    success: true
                                };
                            } else {
                                result = {
                                    success: false
                                };
                            }
                            cloudplate.trigger('set_data', result);
                            break;
                        case 'get_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({
                                    code: 105,
                                    msg: '参数传值不对',
                                    data: ''
                                });
                                cloudplate.trigger('get_data', '');
                                break;
                            }
                            var result = '';
                            window.localStorage ? result = window.localStorage.getItem(data.key) : '';
                            window.sessionStorage && result === '' ? result = window.sessionStorage.getItem(data.key) : '';
                            if (window.localStorage || window.sessionStorage) {
                                result = {
                                    success: true,
                                    data: result
                                };
                            } else {
                                result = {
                                    success: false,
                                    data: result
                                };
                            }
                            cloudplate.trigger('get_data', result);
                            break;
                        case 'open_new_page':
                            window.open(data.url)
                            cloudplate.trigger('open_new_page', '打开页面：“' + data.url + '”执行完成');
                            break;
                        case 'set_share':
                            !data.title ? data.title = '分享给你' : '';
                            !data.shareSummary ? data.shareSummary = '分享给你' : '';
                            !data.imgUrl ? data.imgUrl = '' : '';
                            dd && dd.biz.navigation.setRight({
                                show: true,
                                control: true,
                                text: '',
                                onSuccess: function (result) {
                                    dd.biz.util.share({
                                        type: 0,
                                        url: data.link,
                                        content: data.shareSummary,
                                        title: data.title,
                                        image: data.imgUrl,
                                        onSuccess: function () {
                                            cloudplate.trigger('set_share', {
                                                success: true
                                            });
                                        },
                                        onFail: function (err) {
                                            cloudplate.trigger('set_share', {
                                                success: false
                                            });
                                        }
                                    });
                                },
                                onFail: function (err) {
                                    cloudplate.trigger('set_share', {
                                        success: false
                                    });
                                }
                            });
                            break;
                        case 'show_share':
                            !data.title ? data.title = '分享给你' : '';
                            !data.shareTo ? data.shareTo = 'all' : '';
                            !data.shareSummary ? data.shareSummary = '分享给你' : '';
                            !data.id ? data.id = 0 : '';
                            !data.type ? data.type = 'share' : '';
                            !data.datatype ? data.datatype = 'link' : '';
                            !data.dataUrl ? data.dataUrl = 0 : '';
                            dd && dd.biz.util.share({
                                type: 0,
                                url: data.link,
                                content: data.shareSummary,
                                title: data.title,
                                image: data.imgUrl,
                                onSuccess: function () {
                                    cloudplate.trigger('get_share_result', {
                                        success: true
                                    });
                                },
                                onFail: function (err) {
                                    cloudplate.trigger('get_share_result', {
                                        success: false
                                    });
                                }
                            });
                            break;
                        case 'url_redirect':
                            window.location.href = data.url;
                            break;
                        case 'open_in_app':
                            if (!data.defaultClient) {
                                cloudplate.trigger('open_in_app', {
                                    success: '0'
                                });
                            }
                            if (data.defaultClient && data.defaultClient.client_code) {
                                Tools.callInApp(data, client_info.client_code);
                            } else {
                                driverIncompatible(data, 'open_in_app');
                                cloudplate.trigger('open_in_app', {
                                    success: '0'
                                });
                            }
                            break;
                        case 'open_county_home_page':
                            window.location.href = data.url;
                            break;
                        default:
                            driverIncompatible(data, event);
                            cloudplate.trigger(event, '');
                            break;
                    }
                }
            },
            phone_web: {
                driver_params: {},
                preloadfiles: ['https://static.mlinks.cc/scripts/dist/mlink.min.js'],
                check: function (callback) {
                    console && console.log('browser', Tools.browser());
                    console && console.log('version', _cp_config.version);
                    if (Tools.browser() == 'phone') { callback({ client_code: 'phone_web', version: '1.0', detail: '' }); }
                },
                load: function (client_info, callback) { callback(client_info); },
                init: function (options, client_info) {
                    var driver_var = this;
                    driver_var['_options'] = options;
                    options.ready(client_info);
                },
                delegate: function (event, data, client_info) {
                    data = data ? data : '';
                    var _options = this._options;
                    switch (event) {
                        case 'show_login':
                            driverIncompatible(data, 'show_login');
                            cloudplate.trigger('show_login', '');
                            break;
                        case 'is_login':
                            driverIncompatible(data, 'is_login');
                            cloudplate.trigger('is_login', { is_login: '' });
                            break;
                        case 'get_unique_id':
                            driverIncompatible(data, 'get_unique_id');
                            cloudplate.trigger('get_unique_id', { unique_id: '' });
                            break;
                        case 'get_account_id':
                            driverIncompatible(data, 'get_account_id');
                            cloudplate.trigger('get_account_id', { account_id: '' });
                            break;
                        case 'open_new_page':
                            window.open(data.url)
                            cloudplate.trigger('open_new_page', '打开页面：“' + data.url + '”执行完成');
                            break;
                        case 'get_client_info':
                            cloudplate.trigger('get_client_info', { client_code: 'phone_web', version: '1.0', detail: '' });
                            break;
                        case 'get_device_info':
                            driverIncompatible(data, 'get_device_info');
                            cloudplate.trigger('get_device_info', '');
                            break;
                        case 'reset':
                            break;
                        case 'get_css_mode':
                            driverIncompatible(data, 'get_css_mode');
                            cloudplate.trigger('get_css_mode', '');
                            break;
                        case 'show_share':
                            driverIncompatible(data, 'show_share');
                            cloudplate.trigger('show_share', '');
                            break;
                        case 'get_location_info':
                            driverIncompatible(data, 'get_location_info');
                            cloudplate.trigger('address_change', { speed: '', accuracy: '', lat: '', lon: '', radius: '', city: '', addr: '' });
                            break;
                        case 'get_customer_info':
                            driverIncompatible(data, 'get_customer_info');
                            cloudplate.trigger('get_customer_info', '');
                            break;
                        case 'get_download_info':
                            driverIncompatible(data, 'get_download_info');
                            cloudplate.trigger('get_download_info', '');
                            break;
                        case 'get_ip':
                            driverIncompatible(data, 'get_ip');
                            cloudplate.trigger('get_ip', '');
                            break;
                        case 'get_image':
                            driverIncompatible(data, 'get_image');
                            cloudplate.trigger('get_image', '');
                            break;
                        case 'get_voice':
                            driverIncompatible(data, 'get_voice');
                            cloudplate.trigger('get_voice', '');
                            break;
                        case 'start_voice':
                            driverIncompatible(data, 'start_voice');
                            cloudplate.trigger('start_voice', '');
                            break;
                        case 'file_upload':
                            driverIncompatible(data, 'file_upload');
                            cloudplate.trigger('file_upload', '');
                            break;
                        case 'stop_voice':
                            driverIncompatible(data, 'stop_voice');
                            cloudplate.trigger('stop_voice', '');
                            break;
                        case 'get_video':
                            driverIncompatible(data, 'get_video');
                            cloudplate.trigger('get_video', '');
                            break;
                        case 'get_scan_qr':
                            driverIncompatible(data, 'get_scan_qr');
                            cloudplate.trigger('get_scan_qr', '');
                            break;
                        case 'search_beacons':
                            driverIncompatible(data, 'search_beacons');
                            cloudplate.trigger('search_beacons', '');
                            break;
                        case 'shake':
                            driverIncompatible(data, 'shake');
                            cloudplate.trigger('shake', '');
                            break;
                        case 'close':
                            if (window && typeof (window.close) == 'function') { window.close(); } else { driverIncompatible(data, 'close'); }
                            break;
                        case 'set_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('set_data', '');
                                break;
                            }
                            window.localStorage && window.localStorage.setItem(data.key, data.value);
                            window.sessionStorage && window.sessionStorage.setItem(data.key, data.value);
                            var result = '';
                            if (window.localStorage || window.sessionStorage) { result = { success: true }; } else { result = { success: false }; }
                            cloudplate.trigger('set_data', result);
                            break;
                        case 'get_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('get_data', '');
                                break;
                            }
                            var result = '';
                            window.localStorage ? result = window.localStorage.getItem(data.key) : '';
                            window.sessionStorage && result === '' ? result = window.sessionStorage.getItem(data.key) : '';
                            if (window.localStorage || window.sessionStorage) { result = { success: true, data: result }; } else { result = { success: false, data: result }; }
                            cloudplate.trigger('get_data', result);
                            break;
                        case 'set_share':
                            driverIncompatible(data, 'set_share');
                            cloudplate.trigger('set_share', '');
                            break;
                        case 'play_voice':
                            break;
                        case 'pause_play_voice':
                            break;
                        case 'stop_play_voice':
                            break;
                        case 'url_redirect':
                            window.location.href = data.url;
                            break;
                        case 'bindmobile':
                            driverIncompatible(data, 'bindmobile');
                            cloudplate.trigger('bindmobile', '');
                            break;
                        case 'is_bindmobile':
                            driverIncompatible(data, 'is_bindmobile');
                            cloudplate.trigger('is_bindmobile', '');
                            break;
                        case 'redpacket_open_success':
                            driverIncompatible(data, 'redpacket_open_success');
                            cloudplate.trigger('redpacket_open_success', { success: '1' });
                            break;
                        case 'show_modify_mobile':
                            driverIncompatible(data, 'modify_mobile');
                            cloudplate.trigger('modify_mobile', { success: '0' });
                            break;
                        case 'open_in_app':
                            if (!data.defaultClient) { cloudplate.trigger('open_in_app', { success: '0' }); }
                            if (data.defaultClient && data.defaultClient.client_code) { Tools.callInApp(data, client_info.client_code); } else {
                                driverIncompatible(data, 'open_in_app');
                                cloudplate.trigger('open_in_app', { success: '0' });
                            }
                            break;
                        case 'open_county_home_page':
                            window.location.href = data.url;
                            break;
                        default:
                            driverIncompatible(data, event);
                            cloudplate.trigger(event, '');
                            break;
                    }
                }
            },
            web: {
                driver_params: {},
                preloadfiles: ['https://static.mlinks.cc/scripts/dist/mlink.min.js'],
                check: function (callback) { if (Tools.browser() == 'pc') { callback({ client_code: 'web', version: '1.0', detail: '' }); } },
                load: function (client_info, callback) { callback(client_info); },
                init: function (options, client_info) {
                    var driver_var = this;
                    driver_var['_options'] = options;
                    options.ready(client_info);
                },
                delegate: function (event, data, client_info) {
                    var _options = this._options;
                    data = data ? data : '';
                    switch (event) {
                        case 'show_login':
                            driverIncompatible(data, 'show_login');
                            cloudplate.trigger('show_login', '');
                            break;
                        case 'is_login':
                            driverIncompatible(data, 'is_login');
                            cloudplate.trigger('is_login', '');
                            break;
                        case 'get_unique_id':
                            driverIncompatible(data, 'get_unique_id');
                            cloudplate.trigger('get_unique_id', '');
                            break;
                        case 'get_account_id':
                            driverIncompatible(data, 'get_account_id');
                            cloudplate.trigger('get_account_id', '');
                            break;
                        case 'get_client_info':
                            cloudplate.trigger('get_client_info', { client_code: 'web', version: '1.0', detail: '' });
                            break;
                        case 'open_new_page':
                            window.open(data.url)
                            cloudplate.trigger('open_new_page', '打开页面：“' + data.url + '”执行完成');
                            break;
                        case 'get_device_info':
                            driverIncompatible(data, 'get_device_info');
                            cloudplate.trigger('get_device_info', '');
                            break;
                        case 'reset':
                            driverIncompatible(data, 'reset');
                            cloudplate.trigger('reset', '');
                            break;
                        case 'get_css_mode':
                            driverIncompatible(data, 'get_css_mode');
                            cloudplate.trigger('get_css_mode', '');
                            break;
                        case 'show_share':
                            driverIncompatible(data, 'show_share');
                            cloudplate.trigger('show_share', '');
                            break;
                        case 'get_location_info':
                            driverIncompatible(data, 'get_location_info');
                            cloudplate.trigger('address_change', '');
                            break;
                        case 'get_customer_info':
                            driverIncompatible(data, 'get_customer_info');
                            cloudplate.trigger('get_customer_info', '');
                            break;
                        case 'get_download_info':
                            driverIncompatible(data, 'get_download_info');
                            cloudplate.trigger('get_download_info', '');
                            break;
                        case 'get_ip':
                            driverIncompatible(data, 'get_ip');
                            cloudplate.trigger('get_ip', '');
                            break;
                        case 'get_image':
                            driverIncompatible(data, 'get_image');
                            cloudplate.trigger('get_image', '');
                            break;
                        case 'get_voice':
                            driverIncompatible(data, 'get_voice');
                            cloudplate.trigger('get_voice', '');
                            break;
                        case 'start_voice':
                            driverIncompatible(data, 'start_voice');
                            cloudplate.trigger('start_voice', '');
                            break;
                        case 'file_upload':
                            driverIncompatible(data, 'file_upload');
                            cloudplate.trigger('file_upload', '');
                            break;
                        case 'stop_voice':
                            driverIncompatible(data, 'stop_voice');
                            cloudplate.trigger('stop_voice', '');
                            break;
                        case 'get_video':
                            driverIncompatible(data, 'get_video');
                            cloudplate.trigger('get_video', '');
                            break;
                        case 'get_scan_qr':
                            driverIncompatible(data, 'get_scan_qr');
                            cloudplate.trigger('get_scan_qr', '');
                            break;
                        case 'search_beacons':
                            driverIncompatible(data, 'search_beacons');
                            cloudplate.trigger('search_beacons', '');
                            break;
                        case 'shake':
                            driverIncompatible(data, 'shake');
                            cloudplate.trigger('shake', '');
                            break;
                        case 'close':
                            if (window && typeof (window.close) == 'function') { window.close(); } else { driverIncompatible(data, 'close'); }
                            break;
                        case 'set_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('set_data', '');
                                break;
                            }
                            window.localStorage && window.localStorage.setItem(data.key, data.value);
                            window.sessionStorage && window.sessionStorage.setItem(data.key, data.value);
                            var result = '';
                            if (window.localStorage || window.sessionStorage) { result = { success: true }; } else { result = { success: false }; }
                            cloudplate.trigger('set_data', result);
                            break;
                        case 'get_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('get_data', '');
                                break;
                            }
                            var result = '';
                            window.localStorage ? result = window.localStorage.getItem(data.key) : '';
                            window.sessionStorage && result === '' ? result = window.sessionStorage.getItem(data.key) : '';
                            if (window.localStorage || window.sessionStorage) { result = { success: true, data: result }; } else { result = { success: false, data: result }; }
                            cloudplate.trigger('get_data', result);
                            break;
                        case 'set_share':
                            driverIncompatible(data, 'set_share');
                            cloudplate.trigger('set_share', '');
                            break;
                        case 'play_voice':
                            break;
                        case 'pause_play_voice':
                            break;
                        case 'stop_play_voice':
                            break;
                        case 'url_redirect':
                            window.location.href = data.url;
                            break;
                        case 'bindmobile':
                            driverIncompatible(data, 'bindmobile');
                            cloudplate.trigger('bindmobile', '');
                            break;
                        case 'is_bindmobile':
                            driverIncompatible(data, 'is_bindmobile');
                            cloudplate.trigger('is_bindmobile', '');
                            break;
                        case 'redpacket_open_success':
                            driverIncompatible(data, 'redpacket_open_success');
                            cloudplate.trigger('redpacket_open_success', { success: '1' });
                            break;
                        case 'show_modify_mobile':
                            driverIncompatible(data, 'modify_mobile');
                            cloudplate.trigger('modify_mobile', { success: '0' });
                            break;
                        case 'open_in_app':
                            if (!data.defaultClient) { cloudplate.trigger('open_in_app', { success: '0' }); }
                            if (data.defaultClient && data.defaultClient.client_code) { Tools.callInApp(data, client_info.client_code); } else {
                                driverIncompatible(data, 'open_in_app');
                                cloudplate.trigger('open_in_app', { success: '0' });
                            }
                            break;
                        case 'open_county_home_page':
                            window.location.href = data.url;
                            break;
                        default:
                            driverIncompatible(data, event);
                            cloudplate.trigger(event, '');
                            break;
                    }
                }
            },
            wb: {
                driver_params: {},
                check: function (callback) {
                    if (Tools.browser() == 'wb') {
                        driverIsLoading = true;
                        callback({ client_code: 'wb', version: '1.0', detail: '', is_client: '0' });
                    }
                },
                load: function (client_info, callback) { callback(client_info); },
                init: function (options, client_info) {
                    var driver_var = this;
                    driver_var['_options'] = options;
                    options.ready(client_info);
                },
                filterUrl: function (url) { return url; },
                delegate: function (event, data, client_info) {
                    var _options = this._options;
                    data = data ? data : '';
                    switch (event) {
                        case 'show_login':
                            driverIncompatible(data, 'show_login');
                            cloudplate.trigger('show_login', '');
                            break;
                        case 'is_login':
                            driverIncompatible(data, 'is_login');
                            cloudplate.trigger('is_login', '');
                            break;
                        case 'get_unique_id':
                            driverIncompatible(data, 'get_unique_id');
                            cloudplate.trigger('get_unique_id', '');
                            break;
                        case 'get_account_id':
                            driverIncompatible(data, 'get_account_id');
                            cloudplate.trigger('get_account_id', '');
                            break;
                        case 'get_client_info':
                            cloudplate.trigger('get_client_info', { client_code: 'wb', version: '1.0', detail: '' });
                            break;
                        case 'open_new_page':
                            window.open(data.url)
                            cloudplate.trigger('open_new_page', '打开页面：“' + data.url + '”执行完成');
                            break;
                        case 'get_device_info':
                            driverIncompatible(data, 'get_device_info');
                            cloudplate.trigger('get_device_info', '');
                            break;
                        case 'reset':
                            driverIncompatible(data, 'reset');
                            cloudplate.trigger('reset', '');
                            break;
                        case 'get_css_mode':
                            driverIncompatible(data, 'get_css_mode');
                            cloudplate.trigger('get_css_mode', '');
                            break;
                        case 'show_share':
                            driverIncompatible(data, 'show_share');
                            cloudplate.trigger('show_share', '');
                            break;
                        case 'get_location_info':
                            driverIncompatible(data, 'get_location_info');
                            cloudplate.trigger('address_change', '');
                            break;
                        case 'get_customer_info':
                            driverIncompatible(data, 'get_customer_info');
                            cloudplate.trigger('get_customer_info', '');
                            break;
                        case 'get_download_info':
                            driverIncompatible(data, 'get_download_info');
                            cloudplate.trigger('get_download_info', '');
                            break;
                        case 'get_ip':
                            driverIncompatible(data, 'get_ip');
                            cloudplate.trigger('get_ip', '');
                            break;
                        case 'get_image':
                            driverIncompatible(data, 'get_image');
                            cloudplate.trigger('get_image', '');
                            break;
                        case 'get_voice':
                            driverIncompatible(data, 'get_voice');
                            cloudplate.trigger('get_voice', '');
                            break;
                        case 'start_voice':
                            driverIncompatible(data, 'start_voice');
                            cloudplate.trigger('start_voice', '');
                            break;
                        case 'file_upload':
                            driverIncompatible(data, 'file_upload');
                            cloudplate.trigger('file_upload', '');
                            break;
                        case 'stop_voice':
                            driverIncompatible(data, 'stop_voice');
                            cloudplate.trigger('stop_voice', '');
                            break;
                        case 'get_video':
                            driverIncompatible(data, 'get_video');
                            cloudplate.trigger('get_video', '');
                            break;
                        case 'get_scan_qr':
                            driverIncompatible(data, 'get_scan_qr');
                            cloudplate.trigger('get_scan_qr', '');
                            break;
                        case 'search_beacons':
                            driverIncompatible(data, 'search_beacons');
                            cloudplate.trigger('search_beacons', '');
                            break;
                        case 'shake':
                            driverIncompatible(data, 'shake');
                            cloudplate.trigger('shake', '');
                            break;
                        case 'close':
                            if (window && typeof (window.close) == 'function') { window.close(); } else { driverIncompatible(data, 'close'); }
                            break;
                        case 'set_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('set_data', '');
                                break;
                            }
                            window.localStorage && window.localStorage.setItem(data.key, data.value);
                            window.sessionStorage && window.sessionStorage.setItem(data.key, data.value);
                            var result = '';
                            if (window.localStorage || window.sessionStorage) { result = { success: true }; } else { result = { success: false }; }
                            cloudplate.trigger('set_data', result);
                            break;
                        case 'get_data':
                            if (data.storage !== 0 && data.storage !== '0' && data.storage !== 1 && data.storage !== '1') {
                                Tools.setError({ code: 105, msg: '参数传值不对', data: '' });
                                cloudplate.trigger('get_data', '');
                                break;
                            }
                            var result = '';
                            window.localStorage ? result = window.localStorage.getItem(data.key) : '';
                            window.sessionStorage && result === '' ? result = window.sessionStorage.getItem(data.key) : '';
                            if (window.localStorage || window.sessionStorage) { result = { success: true, data: result }; } else { result = { success: false, data: result }; }
                            cloudplate.trigger('get_data', result);
                            break;
                        case 'set_share':
                            driverIncompatible(data, 'set_share');
                            cloudplate.trigger('set_share', '');
                            break;
                        case 'play_voice':
                            break;
                        case 'pause_play_voice':
                            break;
                        case 'stop_play_voice':
                            break;
                        case 'url_redirect':
                            window.location.href = data.url;
                            break;
                        case 'bindmobile':
                            driverIncompatible(data, 'bindmobile');
                            cloudplate.trigger('bindmobile', '');
                            break;
                        case 'is_bindmobile':
                            driverIncompatible(data, 'is_bindmobile');
                            cloudplate.trigger('is_bindmobile', '');
                            break;
                        case 'redpacket_open_success':
                            driverIncompatible(data, 'redpacket_open_success');
                            cloudplate.trigger('redpacket_open_success', { success: '1' });
                            break;
                        case 'show_modify_mobile':
                            driverIncompatible(data, 'modify_mobile');
                            cloudplate.trigger('modify_mobile', { success: '0' });
                            break;
                        case 'open_in_app':
                            if (!data.defaultClient) { cloudplate.trigger('open_in_app', { success: '0' }); }
                            if (data.defaultClient && data.defaultClient.client_code) { Tools.callInApp(data, client_info.client_code); } else {
                                driverIncompatible(data, 'open_in_app');
                                cloudplate.trigger('open_in_app', { success: '0' });
                            }
                            break;
                        case 'open_county_home_page':
                            window.location.href = data.url;
                            break;
                        default:
                            driverIncompatible(data, event);
                            cloudplate.trigger(event, '');
                            break;
                    }
                }
            }
        };
        var driverIncompatible = function (data, fn_name, need_update) {
            fn_name = fn_name ? fn_name : '';
            need_update = need_update ? need_update : false;
            var error = { code: 3, msg: fn_name + ' 方法在此版本中不可用，请升级版本~', data: { 'method': fn_name } };
            if (need_update) { error.msg = fn_name + ' 方法在此版本中不可用，请升级版本~'; } else { error.msg = fn_name + ' 方法此环境不支持~'; }
            Tools.setError(error);
            if (data.hasOwnProperty('cp_incompatible') && typeof (data.cp_incompatible) == 'function') {
                if (typeof (data['_cp_event']) == 'object') { for (var index in data['_cp_event']) { if (data['_cp_event'][index] && typeof (data['_cp_event'][index]) == 'object' && data['_cp_event'][index].length) { for (var key in data['_cp_event'][index]) { Core.remove(data['_cp_event'][index][key], index); } } } }
                data.cp_incompatible(error);
            }
        };
        var loadDriver = function (client_info, readycallback) {
            var index = client_info.client_code;
            index = index == 'app_embed' ? 'trsAppJSBridge' : index;
            if (!drivers[index]) { return false; }
            drivers[index].load(client_info, function (params) {
                drivers[index].driver_params = params ? params : {};
                readycallback(drivers[index], client_info);
            });
        };
        var getDriver = function (readycallback) {
            if (drivers) {
                var is_loaded = false;
                for (var index in drivers) {
                    drivers[index].check(function (client_info) {
                        if (is_loaded) { return; }
                        is_loaded = true;
                        loadDriver(client_info, readycallback);
                    });
                }
                return;
            }
        };
        getDriver(readycallback);
    };
    var Request = {
        _requestQueue: [],
        _resourcePool: {},
        _is_jsonp_called: false,
        _getStyle: function (src, func) {
            var cssstyle = document.createElement('link');
            cssstyle.async = "async";
            cssstyle.href = src;
            cssstyle.rel = 'stylesheet';
            cssstyle.type = 'text/css';
            cssstyle.charset = "UTF-8";
            if (func) { cssstyle.onload = func; }
            document.head.appendChild(cssstyle);
        },
        _getScript: function (src, func) {
            var script = document.createElement('script');
            script.async = "async";
            script.src = src;
            script.charset = "UTF-8";
            if (func) { script.onload = func; }
            document.body.appendChild(script);
        },
        _checkRequestQueue: function (resources) {
            for (var index in this._requestQueue) {
                var flag = true,
                    current = false;
                if (!this._requestQueue[index]) { continue; }
                if (resources === this._requestQueue[index].resources) { current = true; }
                for (var k in this._requestQueue[index].resources) { if (this._resourcePool.hasOwnProperty(this._requestQueue[index].resources[k]) && this._resourcePool[this._requestQueue[index].resources[k]] !== 2) { flag = false; } }
                if (flag) {
                    var done = this._requestQueue[index].callback;
                    this._requestQueue[index] = null;
                    timeout(done);
                    if (current) { return true; }
                }
            }
            return false;
        },
        _loadResourcePool: function () {
            var request = this;
            for (var index in this._resourcePool) {
                if (!this._resourcePool[index]) {
                    var ext_index = index.lastIndexOf(".");
                    var ext = index.substr(ext_index + 1);
                    if (ext === 'js' || ext === 'JS') {
                        this._resourcePool[index] = 1;
                        this._getScript(index, function () {
                            request._resourcePool[index] = 2;
                            request._checkRequestQueue();
                        });
                    } else if (ext === 'css' || ext === 'CSS') {
                        this._getStyle(index);
                        this._resourcePool[index] = 2;
                    }
                }
            }
        },
        _loadResource: function (resources, callback, callbackparams) {
            var request = this;
            callbackparams = callbackparams ? callbackparams : '';
            var item = { resources: resources, callback: function () { typeof callback == 'function' && callback(callbackparams); } };
            request._requestQueue.push(item);
            for (var index in resources) { if (!request._resourcePool.hasOwnProperty(resources[index]) && typeof index == 'string' && (typeof resources[index] == 'string' && (resources[index].indexOf('http') > -1 || resources[index].indexOf('https') > -1))) { request._resourcePool[resources[index]] = 0; } }
            if (request._checkRequestQueue(resources)) { return true; }
            request._loadResourcePool();
        },
        loadContext: function (requires, callback) {
            var request = this;
            var ok = true;
            var checkpool = function (require_callback, option) {
                var flag = true;
                for (var i in request._resourcePool) { if (!request._resourcePool[i] || request._resourcePool[i] !== 2) { flag = flag && false; } }
                if (flag) { callback(); }
            };
            if (!requires || requires === {}) { callback(); }
            for (var index in requires) {
                var check_array = index.split(".");
                if (requires[index].hasOwnProperty('options') && requires[index]['options']['is_activity'] && (eval('typeof ' + check_array[0] + ' == "undefined";') || check_array[1] && eval('typeof ' + index + ' == "undefined";'))) {
                    ok = false;
                    this._loadResource(requires[index]['source'], function (key) {
                        requires[key]['require_callback'](requires[key]['options']);
                        checkpool();
                    }, index);
                }
            }
            if (ok) { callback(); }
        }
    };
    var Tools = {
        ajax: function () {
            var _options = { url: null, type: 'GET', data: null, dataType: 'text', jsonp: 'callback', jsonpCallback: 'jsonpCallback', async: true, cache: true, timeout: null, contentType: 'application/x-www-form-urlencoded', success: null, fail: null };
            var _param = function _param(data) {
                var str = '';
                if (!data || _empty(data)) { return str; }
                if (data instanceof FormData) { return data; }
                for (var key in data) { str += key + '=' + data[key] + '&'; }
                str = str.slice(0, -1);
                return str;
            };
            var _empty = function _empty(obj) {
                for (var key in obj) { return false; }
                return true;
            };
            var _extend = function _extend(target, options) {
                if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || (typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') { return; }
                var copy, clone, name;
                for (name in options) { if (options.hasOwnProperty(name) && !target.hasOwnProperty(name)) { target[name] = options[name]; } }
                return target;
            };
            var parseJSON = function parseJSON(text) {
                if (typeof text !== 'string') { return; }
                if (JSON && JSON.parse) { return JSON.parse(text); }
                return new Function('return ' + text)();
            };

            function _sendJsonpRequest(url, callbackName, succCallback, failCallback) {
                var script = document.createElement('script');
                script.type = "text/javascript";
                script.src = url;
                document.body.appendChild(script);
                window[callbackName] = window[callbackName] || succCallback;
                timeout(function () { if (!Request._is_jsonp_called) { failCallback(); } }, 4000);
            }
            return function (options) {
                if (!options || !options.url) { throw '参数错误！'; }
                options.type = options.type.toUpperCase();
                _extend(options, _options);
                var search = '';
                var param = _param(options.data);
                if (options.type === 'GET' && param) {
                    search = (options.url.indexOf('?') > -1 ? '&' : '?') + param;
                    if (!options.cache) { search += '&radom=' + Math.random(); }
                    param = null;
                }
                if (options.dataType === 'jsonp') {
                    options.url = options.url + search;
                    var jsonpUrl = options.url.indexOf('?') > -1 ? options.url : options.url + '?' + options.jsonp + '=' + options.jsonpCallback;
                    _sendJsonpRequest(jsonpUrl, options.jsonpCallback, options.success, options.fail);
                    return;
                }
                var xhr = new (window.XMLHttpRequest || ActiveXObject)('Microsoft.XMLHTTP');
                xhr.open(options.type, options.url + search, options.async);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 4) {
                        if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304) {
                            var text = xhr.responseText;
                            if (options.dataType == 'json') { text = parseJSON(text); }
                            if (typeof options.success === 'function') { options.success(text, xhr.status); }
                        } else { if (typeof options.fail === 'function') { options.fail('获取失败', 500); } }
                    }
                };
                if (options.contentType != 'multipart/form-data') { xhr.setRequestHeader('content-type', options.contentType); }
                xhr.send(param);
                if (typeof options.timeout === 'number') { if (xhr.timeout) { xhr.timeout = options.timeout; } else { setTimeout(function () { xhr.abort(); }, options.timeout); } }
            };
        }(),
        /**
         * @name: checkIsInWechatPCBrowser
         * @msg: 检测环境是否在微信PC端浏览器
         * @param {type} 暂无
         * @return {type} 暂无
         */
        checkIsInWechatPCBrowser: function () {
            var isInPCBrowser = false;
            var system = {
                win: false,
                mac: false,
                xll: false,
                ipad: false
            };
            // 检测平台   
            var p = navigator.platform;
            system.win = p.indexOf('Win') == 0;
            system.mac = p.indexOf('Mac') == 0;
            system.x11 = (p == 'X11') || (p.indexOf('Linux') == 0);
            system.ipad = (navigator.userAgent.match(/iPad/i) != null) ? true : false;
            if (system.win || system.mac || system.xll || system.ipad) {
                console.log('在PC端上打开的');
                isInPCBrowser = true;
            }
            return isInPCBrowser;
        },
        random: function () {
            if (Math && Math.round) { return Math.round(Math.random() * 100000000000) + (new Date()).valueOf(); }
            return false;
        },
        sleep: function (delay, extFun, callback) {
            extFun = extFun ? extFun : function () { return false; };
            callback = callback ? callback : function () { };
            var start = (new Date()).getTime();
            while (((new Date()).getTime() - start < delay) && !extFun()) { continue; }
            callback();
        },
        contains: function (arr, obj) {
            var i = arr.length;
            while (i--) { if (arr[i] === obj) { return true; } }
            return false;
        },
        writelog: function (key, $data, level) {
            $data = $data ? $data : '';
            level = level ? level : 'log';
            var date = '';
            if (typeof Date == 'function') {
                function CurentTime() {
                    var now = new Date();
                    var year = now.getFullYear();
                    var month = now.getMonth() + 1;
                    var day = now.getDate();
                    var hh = now.getHours();
                    var mm = now.getMinutes();
                    var ss = now.getSeconds();
                    var clock = year + "-";
                    if (month < 10)
                        clock += "0";
                    clock += month + "-";
                    if (day < 10)
                        clock += "0";
                    clock += day + " ";
                    if (hh < 10)
                        clock += "0";
                    clock += hh + ":";
                    if (mm < 10)
                        clock += '0';
                    clock += mm + ":";
                    if (ss < 10)
                        clock += '0';
                    clock += ss;
                    return (clock);
                }
                date = CurentTime();
            }
            if (CP && CP._options && CP._options.debug) {
                if (console && console.hasOwnProperty(level)) { console[level](date + ' ' + key, $data); } else {
                    var p = document.createElement("p");
                    var content = '';
                    if ((typeof $data == 'string') && $data.constructor == String || typeof $data == 'boolean') { content = $data; } else { content = JSON.stringify($data); }
                    p.innerText = date + ' ' + key + ' : ' + content;
                    document.body.appendChild(p);
                }
            } else { }
        },
        browser: function (detail) {
            if (!navigator || !navigator.userAgent) { return ''; }
            var sUserAgent = navigator.userAgent.toLowerCase();
            var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
            var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
            var bIsMidp = sUserAgent.match(/midp/i) == "midp";
            var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
            var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
            var bIsWeiBo = sUserAgent.match(/weibo/i) == "weibo";
            var bIsAndroid = sUserAgent.match(/android/i) == "android";
            var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
            var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
            var bIswx = sUserAgent.match(/MicroMessenger/i) == "micromessenger";
            var bIsTrs = sUserAgent.match(/trs/i) == "trs";
            var bIsqq = sUserAgent.match(/QQ/) == "QQ";
            var bIsdd = sUserAgent.match(/dingtalk/) == "dingtalk";
            if (!bIsqq) { bIsqq = sUserAgent.match(/qq\//i) == "qq/"; }
            var bIsqqbower = sUserAgent.match(/mqqbrowser/i) == "mqqbrowser";
            if (bIsqqbower && !bIswx) { bIsqq = true; }
            if (detail) { if (bIswx) { return 'wx'; } else if (bIsIpad) { return 'ipad'; } else if (bIsIphoneOs) { return 'iphone os'; } else if (bIsMidp) { return 'midp'; } else if (bIsUc7) { return 'UC7'; } else if (bIsUc) { return 'ucweb'; } else if (bIsAndroid) { return 'android'; } else if (bIsCE) { return 'windows ce'; } else if (bIsWM) { return 'windows mobile'; } }
            if (bIsTrs) { return 'trs'; }
            if (bIsqq) { return 'qq'; }
            if (bIswx) { return 'wx'; }
            if (bIsdd) { return 'dd'; }
            if (bIsWeiBo) { return 'wb'; }
            if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIswx || bIsdd) { return 'phone'; } else { return 'pc'; }
        },
        createAudioElement: function (option) {
            var audio = document.createElement('audio');
            audio.id = 'audio_' + this.random() + '_' + new Date().getTime();
            audio.src = '';
            audio.style = 'width:0px;height:0px;border:none;margin:0px;padding:0px;'
            if (option && option.control) { audio.control = option.control; }
            if (option && option.style) { audio.style = option.style; }
            document.body.appendChild(audio);
            return audio.id;
        },
        getRequest: function () {
            var url = location.search;
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                strs = str.split("&");
                for (var i = 0; i < strs.length; i++) { theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]); }
            }
            return theRequest;
        },
        callInApp: function (data, client_info) {
            if (!data.defaultClient || !data.defaultClient.client_code) {
                driverIncompatible(data, 'open_in_app');
                cloudplate.trigger('open_in_app', { success: '0' });
                return false;
            }
            if (data.defaultClient.client_code !== client_info.client_code) { jump(data.defaultClient.client_code, data); } else {
                driverIncompatible(data, 'open_in_app');
                cloudplate.trigger('open_in_app', { success: '0' });
            }

            function jump(client_code, data) {
                var user_agent = navigator.userAgent.toLowerCase();
                var is_android = user_agent.match(/android/ig);
                var is_ios = user_agent.match(/iphone|ipod|ipad/ig);
                var link_url = data.link_url ? data.link_url : window.location.href;
                var request_params = data.id ? data : Tools.getRequest();
                if (client_code === 'zjxw') {
                    var openLink_ios = 'mwzjxw://zj.zjol.com.cn?url=' + encodeURIComponent(link_url);
                    var openLink_android = 'mwzjxw://zj.zjol.com.cn?url=' + link_url;
                    if (is_ios) {
                        var openLink = "http://a.app.qq.com/o/simple.jsp?pkgname=com.zhejiangdaily&ios_scheme=" + encodeURIComponent(openLink_ios);
                        window.open(openLink);
                    } else if (is_android) {
                        var openLink = "http://a.app.qq.com/o/simple.jsp?pkgname=com.zhejiangdaily&android_schema=" + escape(openLink_android);
                        window.open(openLink);
                    }
                } else if (client_code.indexOf('xsb') == 0) {
                    var openLink_android = '';
                    if (request_params.link) { openLink_android = _cp_config._open_params[client_code] + '://' + request_params.link; } else if (request_params.id && request_params.tenantId) { openLink_android = _cp_config._open_params[client_code] + '://vapp.tmuyun.com/webDetails/link?id=' + request_params.id + '&tenantId=' + request_params.tenantId; }
                    if (!openLink_android) { cloudplate.trigger('open_in_app', { success: '0' }); return; }
                    window.open(openLink_android);
                } else if (client_code == 'h24') {
                    var openLink = _cp_config._open_params.h24.protocol + '://com.cmstop.qjwb/web?url=' + data.link;
                    window.open(openLink);
                } else {
                    driverIncompatible(data, 'open_in_app');
                    cloudplate.trigger('open_in_app', { success: '0' });
                }
                return;
            }
        },
        setError: function (data) {
            var code = '',
                msg = '';
            if (data && data.hasOwnProperty('code')) {
                code = data.code;
                msg = data.hasOwnProperty('msg') ? data.msg : '';
            }
            if (data && data.hasOwnProperty('errcode')) {
                code = data.errcode;
                msg = data.hasOwnProperty('errmsg') ? data.errmsg : '';
            }
            if (data && data.hasOwnProperty('errCode')) {
                code = data.errCode;
                msg = data.hasOwnProperty('errMsg') ? data.errMsg : '';
            }
            if (CP && CP._options && typeof (CP._options.error) == 'function') { CP._options.error({ code: code, msg: msg, data: data }); }
            this.writelog('SET ERROR:', { code: code, msg: msg, data: data }, 'error');
        },
        recursionTrform: function (value) {
            if (typeof value === 'string') { value = value.replace(/[\r\n]/g, '<br>'); if (value.indexOf('"') !== -1) { value.indexOf('\\"') !== -1 ? value = value.replace(/"/g, '\\\\"') : value = value.replace(/"/g, '\\\"'); } } else if (typeof value === 'object' && value !== null && !(value instanceof Array)) { for (var index in value) { value[index] = Tools.recursionTrform(value[index]); } }
            return value;
        },
        eventPatch: function (event, data) {
            if ('reset' == event && data.is_login !== 0 && data.is_login !== '0' && data.is_login !== 1 && data.is_login !== '1' && data.account_id && data.unique_id) { data.is_login = '1'; }
            if ('get_device_info' === event && !data.version && CP && CP._driver.hasOwnProperty('client_info') && CP._driver['client_info'].version) { data.version = CP._driver['client_info'].version; }
            return data;
        }
    };
    var Core = {
        synkeys: {},
        timeoutKeys: {},
        events: {
            sys_is_init: { test: function (data) { Tools.writelog('sys_is_init 事件调用成功', data); } },
            sys_jsonp: { test: function (data) { Tools.writelog('sys_jsonp 事件调用成功', data); } },
            is_login: { test: function (data) { Tools.writelog('is_login 事件调用成功', data); } },
            get_unique_id: { test: function (data) { Tools.writelog('get_unique_id 事件调用成功', data); } },
            get_account_id: { test: function (data) { Tools.writelog('get_account_id 事件调用成功', data); } },
            get_client_info: { test: function (data) { Tools.writelog('get_client_info 事件调用成功', data); } },
            get_device_info: { test: function (data) { Tools.writelog('get_device_info 事件调用成功', data); } },
            reset: { test: function (data) { Tools.writelog('reset 事件调用成功', data); } },
            mode_change: { test: function (data) { Tools.writelog('mode_change 事件调用成功', data); } },
            get_share_result: { test: function (data) { Tools.writelog('get_share_result 事件调用成功', data); } },
            address_change: { test: function (data) { Tools.writelog('address_change 事件调用成功', data); } },
            get_customer_info: { test: function (data) { Tools.writelog('get_customer_info 事件调用成功', data); } },
            get_download_info: { test: function (data) { Tools.writelog('get_download_info 事件调用成功', data); } },
            get_ip: { test: function (data) { Tools.writelog('get_ip 事件调用成功', data); } },
            get_image: { test: function (data) { Tools.writelog('get_image 事件调用成功', data); } },
            get_voice: { test: function (data) { Tools.writelog('get_voice 事件调用成功', data); } },
            start_voice: { test: function (data) { Tools.writelog('start_voice 事件调用成功', data); } },
            file_upload: { test: function (data) { Tools.writelog('file_upload 事件调用成功', data); } },
            stop_voice: { test: function (data) { Tools.writelog('stop_voice 事件调用成功', data); } },
            auto_stop_voice: { test: function (data) { Tools.writelog('auto_stop_voice 事件调用成功', data); } },
            get_video: { test: function (data) { Tools.writelog('get_video 事件调用成功', data); } },
            shake: { test: function (data) { Tools.writelog('shake 事件调用成功', data); } },
            close: { test: function (data) { Tools.writelog('close 事件调用成功', data); } },
            set_data: { test: function (data) { Tools.writelog('set_data 事件调用成功', data); } },
            get_data: { test: function (data) { Tools.writelog('get_data 事件调用成功', data); } },
            set_share: { test: function (data) { Tools.writelog('set_share 事件调用成功', data); } },
            play_voice: { test: function (data) { Tools.writelog('play_voice 事件调用成功', data); } },
            pause_play_voice: { test: function (data) { Tools.writelog('pause_play_voice 事件调用成功', data); } },
            stop_play_voice: { test: function (data) { Tools.writelog('stop_play_voice 事件调用成功', data); } },
            get_customer_name: { test: function (data) { Tools.writelog('get_customer_name 事件调用成功', data); } },
            bindmobile: { test: function (data) { Tools.writelog('bindmobile 事件调用成功', data); } },
            is_bindmobile: { test: function (data) { Tools.writelog('is_bindmobile 事件调用成功', data); } },
            get_customer_detail: { test: function (data) { Tools.writelog('get_customer_detail 事件调用成功', data); } },
            redpacket_open_success: { test: function (data) { Tools.writelog('redpacket_open_success 事件调用成功', data); } },
            modify_mobile: { test: function (data) { Tools.writelog('modify_mobile 事件调用成功', data); } },
            open_in_app: { test: function (data) { Tools.writelog('open_in_app 事件调用成功', data); } },
            ydun_get_token: { test: function (data) { Tools.writelog('ydun_get_token 事件调用成功', data); } },
            ydun_start: { test: function (data) { Tools.writelog('ydun_start 事件调用成功', data); } },
            ydun_stop: { test: function (data) { Tools.writelog('ydun_stop 事件调用成功', data); } },
            check_wx_js_api: { test: function (data) { Tools.writelog('check_wx_js_api 事件调用成功', data); } },
            download_image: { test: function (data) { Tools.writelog('download_image 事件调用成功', data); } },
            get_local_img_data: { test: function (data) { Tools.writelog('get_local_img_data 事件调用成功', data); } },
            download_voice: { test: function (data) { Tools.writelog('download_voice 事件调用成功', data); } },
            translate_voice: { test: function (data) { Tools.writelog('translate_voice 事件调用成功', data); } },
            get_network_type: { test: function (data) { Tools.writelog('get_network_type 事件调用成功', data); } },
            open_location: { test: function (data) { Tools.writelog('open_location 事件调用成功', data); } },
            start_search_beacons: { test: function (data) { Tools.writelog('start_search_beacons 事件调用成功', data); } },
            stop_search_beacons: { test: function (data) { Tools.writelog('stop_search_beacons 事件调用成功', data); } },
            on_search_beacons: { test: function (data) { Tools.writelog('on_search_beacons 事件调用成功', data); } },
            hide_menu_items: { test: function (data) { Tools.writelog('hide_menu_items 事件调用成功', data); } },
            show_menu_items: { test: function (data) { Tools.writelog('show_menu_items 事件调用成功', data); } },
            hide_all_non_base_menu_item: { test: function (data) { Tools.writelog('hide_all_non_base_menu_item 事件调用成功', data); } },
            show_all_non_base_menu_item: { test: function (data) { Tools.writelog('show_all_non_base_menu_item 事件调用成功', data); } },
            open_product_specific_view: { test: function (data) { Tools.writelog('open_product_specific_view 事件调用成功', data); } },
            choose_card: { test: function (data) { Tools.writelog('choose_card 事件调用成功', data); } },
            add_card: { test: function (data) { Tools.writelog('add_card 事件调用成功', data); } },
            open_card: { test: function (data) { Tools.writelog('open_card 事件调用成功', data); } },
            choose_wx_pay: { test: function (data) { Tools.writelog('choose_wx_pay 事件调用成功', data); } },
            open_address: { test: function (data) { Tools.writelog('open_address 事件调用成功', data); } },
            modify_delivery_name: { test: function (data) { Tools.writelog('modify_delivery_name 事件调用成功', data); } },
            define_menu: { test: function (data) { Tools.writelog('define_menu 事件调用成功', data); } },
            convert_video: { test: function (data) { Tools.writelog('convert_video 事件调用成功', data); } },
            check_js_api: { test: function (data) { Tools.writelog('check_js_api 事件调用成功', data); } },
            select_media: { test: function (data) { Tools.writelog('select_media 事件调用成功', data); } },
            subscribe_event: { test: function (data) { Tools.writelog('subscribe_event 事件调用成功', data); } },
            preview: { test: function (data) { Tools.writelog('preview 事件调用成功', data); } },
            set_share_success: { test: function (data) { Tools.writelog('set_share_success 事件调用成功', data); } },
            pay_for_reading: { test: function (data) { Tools.writelog('pay_for_reading 事件调用成功', data); } },
            set_top_bar: { test: function (data) { Tools.writelog('set_top_bar 事件调用成功', data); } },
            open_new_page: { test: function (data) { Tools.writelog('open_new_page 事件调用成功', data); } },
            emit: { test: function (data) { Tools.writelog('emit 事件调用成功', data); } },
            open_launch_weapp: { test: function (data) { Tools.writelog('open_launch_weapp 事件调用成功', data); } },
            download_file: { test: function (data) { Tools.writelog('download_file 事件调用成功', data); } },
            open_hoo_app: { test: function (data) { Tools.writelog('open_hoo_app 事件调用成功', data); } },
            go_homepage: { test: function (data) { Tools.writelog('go_homepage 事件调用成功', data); } },
            change_status_style: { test: function (data) { Tools.writelog('change_status_style 事件调用成功', data); } },
            show_dy_mode_videos: { test: function (data) { Tools.writelog('show_dy_mode_videos 事件调用成功', data); } },
            play_audio: { test: function (data) { Tools.writelog('play_audio 事件调用成功', data); } },
            pause_audio: { test: function (data) { Tools.writelog('pause_audio 事件调用成功', data); } },
            query_audio: { test: function (data) { Tools.writelog('query_audio 事件调用成功', data); } }
        },
        synCheck: function (key) { },
        register: function (event, callback, once, timeoutcount, exclusive) {
            once = once === false ? '' : '_once';
            exclusive = exclusive ? '_exclusive' : '';
            if (!(Core.events[event] && Core.events[event])) { return false; }
            var key = event + Tools.random() + once + exclusive;
            if (timeoutcount) {
                var _timeout_fn = timeout(function () {
                    var error = { code: 5, msg: event + ' 回调事件超时~', data: { 'method': event } };
                    Tools.setError(error);
                    cloudplate.trigger(event, { success: '0', code: 5, msg: '回调超时' });
                }, timeoutcount);
                Core.timeoutKeys[key] = _timeout_fn;
            }
            Core.events[event][key] = callback;
            return key;
        },
        remove: function (key, event) {
            if (Core.events[event][key]) {
                Core.clearTimeoutKey(key);
                Core.events[event][key] = null;
            }
        },
        trigger: function (event, json_data, callback, event_unique_key) {
            if (!(Core.events && Core.events[event] && Core.events[event] !== {})) { return false; }
            try { if (typeof json_data == 'string') { var data = JSON.parse(json_data); } else { var data = json_data; } } catch (e) { var data = json_data; console.error(e) }
            try { if (data._cp_event && typeof data._cp_event === 'string') { data._cp_event = JSON.parse(data._cp_event); } } catch (e) { console.error(e) }
            if (data._cp_event && data._cp_event[event]) { event_unique_key = data._cp_event[event][0]; }
            event_unique_key = event_unique_key ? event_unique_key : '';
            if (typeof (data) == 'object' && data.hasOwnProperty('error') && data.error !== 0 && data.error !== '0') { Tools.setError({ code: 106, msg: '网络出错', data: data }); }
            data = Tools.eventPatch(event, data);
            var error_key = '';
            try {
                for (var index in Core.events[event]) {
                    error_key = index;
                    if (typeof Core.events[event][index] !== 'function') { continue; }
                    if ((event_unique_key && event_unique_key == index) || (!event_unique_key && !index.indexOf('_exclusive') != -1)) {
                        var callback_handle = Core.events[event][index];
                        Core.clearTimeoutKey(index);
                        var result = callback_handle(data);
                        if (typeof callback == 'function') { callback(result, data); }
                        if (index && index.indexOf('_once') != -1) { Core.events[event][index] = null; }
                    }
                }
            } catch (e) {
                Core.clearTimeoutKey(error_key);
                Tools.writelog('Error name:', e.name + '(' + event + ':' + error_key + ')');
                Tools.writelog('Error ', e.message);
                Tools.writelog('Error detail', e);
                Tools.setError({ code: 102, msg: e.name, data: e });
            }
        },
        clearTimeoutKey: function (eventKey) {
            if (typeof Core.timeoutKeys[eventKey] == 'number') {
                clearTimeout(Core.timeoutKeys[eventKey]);
                Core.timeoutKeys[eventKey] = null;
            } else if (typeof Core.timeoutKeys[eventKey] == 'object' && Core.timeoutKeys[eventKey] && Core.timeoutKeys[eventKey].value) {
                clearTimeout(Core.timeoutKeys[eventKey].value);
                var relations = Core.timeoutKeys[eventKey]['relations'];
                Core.timeoutKeys[eventKey] = null;
                for (var index in relations) { Core.clearTimeoutKey(index); }
            }
        },
        addTimeoutRelation: function (event, relation_event) {
            var index = '';
            if (typeof Core.timeoutKeys[event] == 'number') {
                var key = Core.timeoutKeys[event];
                Core.timeoutKeys[event] = { value: key, relations: {} };
                if (typeof Core.timeoutKeys[relation_event] == 'number') { index = Core.timeoutKeys[relation_event]; } else if (typeof Core.timeoutKeys[relation_event] == 'object') { index = Core.timeoutKeys[relation_event].value; }
                if (index && Core.timeoutKeys[relation_event]) { Core.timeoutKeys[event]['relations'][relation_event] = index; }
            } else if (typeof Core.timeoutKeys[event] == 'object') {
                if (typeof Core.timeoutKeys[relation_event] == 'number') { index = Core.timeoutKeys[relation_event]; } else if (typeof Core.timeoutKeys[relation_event] == 'object') { index = Core.timeoutKeys[relation_event].value; }
                if (index && Core.timeoutKeys[relation_event]) { Core.timeoutKeys[event]['relations'][relation_event] = index; }
            }
        }
    };
    var CallService = function (initcallback) {
        var default_options = { is_ready: false, is_ready_done: false, debug: _cp_config.debug, es6Require: false, ydunOptions: {}, wxOption: {}, ready: null, shake: function () { }, close: function () { }, error: function (data) { } };
        var require_configs = {
            'JSON.stringify': { options: { is_activity: true, }, optionkey: 'ready', source: [_cp_config.common_file_path + 'lib/json_parse_state.min.js', _cp_config.common_file_path + 'lib/json_parse.min.js', _cp_config.common_file_path + 'lib/json2.min.js'], require_callback: function (options) { return true; } },
            'Math.min': { options: { is_activity: true, }, optionkey: 'ready', source: [_cp_config.common_file_path + 'lib/math.min.js'], require_callback: function (options) { return true; } },
            'Array.of': { options: { is_activity: false, }, optionkey: 'es6Require', source: [_cp_config.common_file_path + 'lib/es6-shim.min.js'], require_callback: function (options) { return true; } },
            'VConsole': {
                options: { is_activity: false, },
                optionkey: 'debug',
                source: [_cp_config.common_file_path + 'lib/vconsole.min.js'],
                require_callback: function (options) {
                    var vConsole = new VConsole();
                    setTimeout(function () { Tools.writelog('window', window.location.href); }, 3000);
                    return true;
                }
            },
            'initWatchman': { options: { is_activity: false, productNumber: '', protocol: '', auto: '', onload: '', onerror: '', }, optionkey: 'ydunOptions', source: [_cp_config.yun_dun_url.url], require_callback: function (options) { return true; } }
        };
        var optionLoadEvent = function (data, event, key) {
            var f_data = {};
            if (typeof (data) == 'string' && data.indexOf("{") === 0) { try { f_data = JSON.parse(data); } catch (e) { Tools.setError({ code: 101, msg: e.name, data: e }); return data; } } else if (typeof (data) == 'object') { f_data = data; }
            if (!f_data.hasOwnProperty('_cp_event')) { f_data['_cp_event'] = {}; }
            if (!f_data._cp_event.hasOwnProperty(event)) { f_data._cp_event[event] = []; }
            f_data['_cp_event'][event].push(key);
            return f_data;
        };
        var filterParams = function (callback, once, data, cancelcallback, stopcallback) {
            if (typeof callback === 'object') { return callback; }
            var result = {};
            if (typeof data === 'string' && data.length > 0) { result = JSON.parse(data); } else if (typeof data === 'object') { result = data; }
            if (typeof result !== 'object') { result = {}; }
            typeof callback === 'function' ? result['completed'] = callback : '';
            result['once'] = once;
            typeof cancelcallback === 'function' ? result['cancel'] = cancelcallback : '';
            typeof stopcallback === 'function' ? result['stop'] = stopcallback : '';
            return result;
        };
        try {
            var apis = {
                _params: {},
                _options: {},
                _driver: {
                    delegate: function (key, data, client_info) {
                        if (!apis._params.count) { apis._params['count'] = 1; }
                        if (apis && apis._options && !apis._options.is_ready_done && (apis._params.count && apis._params.count < 10)) {
                            setTimeout(function () {
                                apis._params.count++;
                                CP && CP._driver && CP._driver.delegate(key, data, client_info);
                            }, 200);
                        }
                        if (apis._params.count >= 10) { Tools.setError({ code: 4, msg: 'js未完全加载，请刷新页面', data: '' }); }
                    },
                    init: function () { }
                },
                _core: Core,
                _request: Request,
                _jsonpCallback: function (data) { Core.trigger('sys_jsonp', data); },
                _init: function () {
                    var api = this;
                    if (!api.start || api.start !== 1) { Tools.setError({ code: '6', msg: 'CP 对象重复加载', data: '' }); return; }

                    function initDriver() {
                        Driver(function (driver, client_info) {
                            api._driver = driver;
                            api._driver['client_info'] = client_info;
                            if (api._options.ready && typeof (api._options.ready) == 'function' && api._options && !api._options.is_ready) {
                                api._options.is_ready = true;
                                Core.trigger('sys_is_init', client_info, function () { api._options.is_ready_done = true; });
                            }
                        });
                    }

                    function loadRequire(options, config) {
                        for (var index in config) {
                            var is_activity = config[index]['options']['is_activity'];
                            var optionkey = config[index]['optionkey'];
                            if (options.hasOwnProperty(optionkey)) {
                                if ('boolean' == typeof (options[optionkey])) { is_activity = options[optionkey]; } else if ('object' != typeof (options[optionkey])) { config[index]['options'] = options[optionkey]; }
                                is_activity = (options[optionkey].hasOwnProperty('is_activity') ? options[optionkey]['is_activity'] : is_activity);
                                config[index]['options']['is_activity'] = is_activity;
                            }
                        }
                        return config;
                    }
                    Request.loadContext(loadRequire(api._options, require_configs), function () {
                        Core.register('sys_is_init', api._ready, true, 10000);
                        initDriver();
                    });
                },
                _ready: function (data) {
                    if (!apis._driver) { return; }
                    var load_resource = [];
                    apis._driver.init(apis._options, data);
                },
                tools: Tools,
                ready: function (options) {
                    var api = this;
                    for (var index in default_options) { if (options.hasOwnProperty(index)) { this._options[index] = options[index]; } else { this._options[index] = default_options[index]; } }
                    api._init();
                },
                getVersion: function () { return _cp_config.version; },
                getUniqueId: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_unique_id', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_unique_id', key);
                    this._driver.delegate('get_unique_id', data, this._driver['client_info']);
                },
                getAccountId: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_account_id', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_account_id', key);
                    this._driver.delegate('get_account_id', data, this._driver['client_info']);
                },
                getClientInfo: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var client_info = { client_code: '', version: '', detail: '' };
                    var key = this._core.register('get_client_info', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_client_info', key);
                    this._driver.delegate('get_client_info', data, this._driver['client_info']);
                },
                getDeviceInfo: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_device_info', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_device_info', key);
                    this._driver.delegate('get_device_info', data, this._driver['client_info']);
                },
                isLogin: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('is_login', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'is_login', key);
                    this._driver.delegate('is_login', data, this._driver['client_info']);
                },
                showLogin: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('reset', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'reset', key);
                    this._driver.delegate('show_login', data, this._driver['client_info']);
                },
                openCountyHomePage: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('open_county_home_page', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'open_county_home_page', key);
                    this._driver.delegate('open_county_home_page', data, this._driver['client_info']);
                },
                getCssMode: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('mode_change', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'mode_change', key);
                    this._driver.delegate('get_css_mode', data, this._driver['client_info']);
                },
                showShare: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_share_result', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_share_result', key);
                    this._driver.delegate('show_share', data, this._driver['client_info']);
                },
                getLocationInfo: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('address_change', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'address_change', key);
                    this._driver.delegate('get_location_info', data, this._driver['client_info']);
                },
                getCustomerInfo: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_customer_info', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_customer_info', key);
                    this._driver.delegate('get_customer_info', data, this._driver['client_info']);
                },
                getDownloadInfo: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_download_info', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_download_info', key);
                    this._driver.delegate('get_download_info', data, this._driver['client_info']);
                },
                getIp: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_ip', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_ip', key);
                    this._driver.delegate('get_ip', data, this._driver['client_info']);
                },
                getImage: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_image', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_image', key);
                    this._driver.delegate('get_image', data, this._driver['client_info']);
                },
                getVoice: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_voice', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_voice', key);
                    this._driver.delegate('get_voice', data, this._driver['client_info']);
                },
                startVoice: function (callback, cancelcallback, stopcallback, once, data) {
                    data = filterParams(callback, once, data, cancelcallback, stopcallback);
                    var key_start = this._core.register('start_voice', data.completed, data.once, data.timeout);
                    var key_get = this._core.register('get_voice', data.stop, data.once, data.timeout);
                    var stop_key = this._core.register('stop_voice', data.stop, data.once, data.timeout);
                    var apis_temp = this;
                    this._core.addTimeoutRelation(stop_key, key_get);
                    this._core.addTimeoutRelation(key_get, stop_key);
                    data = optionLoadEvent(data, 'start_voice', key_start);
                    data = optionLoadEvent(data, 'stop_voice', stop_key);
                    data = optionLoadEvent(data, 'get_voice', key_get);
                    this._params.recording_key = stop_key;
                    if (data && data.maxtime) { this._params.setTimeout_start_voice = setTimeout(function () { apis_temp._driver.delegate('stop_voice', data, this._driver['client_info']); }, data.maxtime); }
                    this._driver.delegate('start_voice', data, this._driver['client_info']);
                },
                stopVoice: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    this._core.remove(this._params.recording_key, 'stop_voice');
                    if (this._params && this._params.setTimeout_start_voice && typeof (this._params.setTimeout_start_voice) == 'number') { clearTimeout(this._params.setTimeout_start_voice); }
                    var key = this._core.register('stop_voice', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'stop_voice', key);
                    this._driver.delegate('stop_voice', data, this._driver['client_info']);
                },
                getVideo: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_video', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_video', key);
                    this._driver.delegate('get_video', data, this._driver['client_info']);
                },
                showScanQr: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_scan_qr', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_scan_qr', key);
                    this._driver.delegate('get_scan_qr', data, this._driver['client_info']);
                },
                searchBeacons: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('search_beacons', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'search_beacons', key);
                    this._driver.delegate('search_beacons', data, this._driver['client_info']);
                },
                fileUpload: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('file_upload', data.completed, data.once, data.timeout);
                    if (data.filename && typeof (data.filename) == 'string' && data.filename.indexOf('.') === -1) {
                        var index1 = data.localfile.lastIndexOf(".");
                        var index2 = data.localfile.length;
                        var type = data.localfile.substring(index1, index2);
                        data.filename = data.filename + type;
                    }
                    data = optionLoadEvent(data, 'file_upload', key);
                    this._driver.delegate('file_upload', data, this._driver['client_info']);
                },
                setData: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('set_data', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'set_data', key);
                    this._driver.delegate('set_data', data, this._driver['client_info']);
                },
                getData: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('get_data', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'get_data', key);
                    this._driver.delegate('get_data', data, this._driver['client_info']);
                },
                setShare: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('set_share', data.completed, data.once, data.timeout);
                    var key_get = this._core.register('set_share_success', data.success, data.once, data.timeout);
                    data = optionLoadEvent(data, 'set_share', key);
                    data = optionLoadEvent(data, 'set_share_success', key_get);
                    this._driver.delegate('set_share', data, this._driver['client_info']);
                },
                authValidate: function (options) { },
                playVoice: function (callback, once, options) {
                    if (!options['address']) { return false; }
                    var eleId = '';
                    if (options['eleId']) { eleId = options['eleId']; }
                    options = filterParams(callback, once, options);
                    if (this._driver.driver_params && this._driver.driver_params.client_code == 'wx') {
                        var key = this._core.register('play_voice', options.completed, options.once, options.timeout);
                        options = optionLoadEvent(options, 'play_voice', key);
                        this._driver.delegate('play_voice', options, this._driver['client_info']);
                        return;
                    }
                    if (!typeof (options.address) == 'string' || !/^(http|https):\/\/$/gi.test(options.address)) { return; }
                    if (!options['eleId']) { eleId = this.tools.createAudioElement(); }
                    var audio = document.getElementById(eleId);
                    audio.src = options['address'];
                    audio.play();
                    if (typeof (options['onPlayEnd']) === 'function') {
                        var is_playFinish = setInterval(function () {
                            if (audio.ended) {
                                options['onPlayEnd']({ 'eleId': eleId });
                                window.clearInterval(is_playFinish);
                            }
                        }, 10);
                    }
                    options.completed({ 'eleId': eleId });
                    return eleId;
                },
                pausePlayVoice: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    if (this._driver.driver_params && this._driver.driver_params.client_code == 'wx') {
                        var key = this._core.register('pause_play_voice', options.completed, options.once, options.timeout);
                        options = optionLoadEvent(options, 'pause_play_voice', key);
                        this._driver.delegate('pause_play_voice', options, this._driver['client_info']);
                        return;
                    }
                    var audio = document.getElementById(options['eleId']);
                    audio.pause();
                    if (options['remove']) { audio.parentNode.removeChild(audio); }
                    options.completed({ 'eleId': options['eleId'] });
                },
                stopPlayVoice: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    if (this._driver.driver_params && this._driver.driver_params.client_code == 'wx') {
                        var key = this._core.register('stop_play_voice', options.completed, options.once, options.timeout);
                        options = optionLoadEvent(options, 'stop_play_voice', key);
                        this._driver.delegate('stop_play_voice', options, this._driver['client_info']);
                        return;
                    }
                    if (options.eleId) {
                        var audio = document.getElementById(options['eleId']);
                        audio.pause();
                        audio.src = '';
                        if (options['remove']) { audio.parentNode.removeChild(audio); }
                        options.completed({ 'eleId': options['eleId'] });
                    }
                },
                closePage: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    this._driver.delegate('close', options, this._driver['client_info']);
                },
                urlRedirect: function (options) { this._driver.delegate('url_redirect', options, this._driver['client_info']); },
                bindMobile: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    var key = this._core.register('bindmobile', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'bindmobile', key);
                    this._driver.delegate('bindmobile', options, this._driver['client_info']);
                },
                isBindMobile: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    var key = this._core.register('is_bindmobile', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'is_bindmobile', key);
                    this._driver.delegate('is_bindmobile', options, this._driver['client_info']);
                },
                redpacketOpenSuccess: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    var key = this._core.register('redpacket_open_success', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'redpacket_open_success', key);
                    this._driver.delegate('redpacket_open_success', options, this._driver['client_info']);
                },
                showModifyMobile: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    var key = this._core.register('modify_mobile', options.completed, options.once, (options.timeout ? options.timeout : 300000));
                    options = optionLoadEvent(options, 'modify_mobile', key);
                    this._driver.delegate('show_modify_mobile', options, this._driver['client_info']);
                },
                openInApp: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    var key = this._core.register('open_in_app', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'open_in_app', key);
                    this._driver.delegate('open_in_app', options, this._driver['client_info']);
                },
                ydunInit: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    var option = this._options;
                    var product_number = options.product_number ? options.product_number : option.product_number;
                    var timer = null;
                    var counter = 0;
                    var init = function () {
                        counter++;
                        if (counter >= 20) { return; }
                        if (typeof (initWatchman) != 'function') { timer = timeout(init, 100); return; }
                        timer = null;
                        initWatchman({
                            productNumber: product_number,
                            protocol: option.protocol ? option.protocol : 'https',
                            auto: option.auto ? option.auto : true,
                            onload: function (instance) {
                                Tools._ydun = instance;
                                options.completed({ success: '1' });
                            },
                            onerror: function (err) { Tools.setError({ code: '2001', msg: err.message, data: err }); }
                        });
                    };
                    if (typeof (initWatchman) != 'function') { timer = timeout(init, 100); } else { init(); }
                },
                ydunStart: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    var key = this._core.register('ydun_start', options.completed, options.once, options.timeout);
                    var _this = this;
                    var timer = null;
                    var counter = 0;
                    var run_ydun = function () {
                        counter++;
                        if (counter >= 10) { _this._core.trigger('ydun_start', { success: '0' }); return; }
                        if (!Tools._ydun) { timer = timeout(this, 100); return; }
                        timer = null;
                        Tools._ydun.start();
                        _this._core.trigger('ydun_start', { success: '1' });
                    };
                    if (Tools._ydun) {
                        Tools._ydun.start();
                        _this._core.trigger('ydun_start', { success: '1' });
                    } else {
                        counter++;
                        timer = timeout(run_ydun, 100);
                    }
                },
                ydunStop: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    var key = this._core.register('ydun_start', options.completed, options.once, options.timeout);
                    var _this = this;
                    var timer = null;
                    var counter = 0;
                    var run_ydun = function () {
                        counter++;
                        if (counter >= 10) { _this._core.trigger('ydun_stop', { success: '0' }); return; }
                        if (!Tools._ydun) { timer = timeout(this, 100); return; }
                        timer = null;
                        Tools._ydun.stop();
                        _this._core.trigger('ydun_stop', { success: '1' });
                    };
                    if (Tools._ydun) {
                        Tools._ydun.stop();
                        _this._core.trigger('ydun_stop', { success: '1' });
                    } else {
                        counter++;
                        timer = timeout(run_ydun, 100);
                    }
                },
                ydunGetToken: function (callback, once, options) {
                    options = filterParams(callback, once, options);
                    var key = this._core.register('ydun_get_token', options.completed, options.once, options.timeout);
                    var _this = this;
                    options.business_id = options.business_id ? options.business_id : '1';
                    var timer = null;
                    var counter = 0;
                    var run_ydun = function () {
                        counter++;
                        if (counter >= 10) { _this._core.trigger('ydun_get_token', { success: '0', token: '' }); return; }
                        if (!Tools._ydun) { timer = timeout(run_ydun, 100); return; }
                        Tools._ydun.getToken(options.business_id, function (data) { _this._core.trigger('ydun_get_token', { success: '1', token: data }); });
                    };
                    if (Tools._ydun) { run_ydun(); } else {
                        counter++;
                        timer = timeout(run_ydun, 100);
                    }
                },
                checkWxJsApi: function (options) {
                    var key = this._core.register('check_wx_js_api', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'check_wx_js_api', key);
                    this._driver.delegate('check_wx_js_api', options, this._driver['client_info']);
                },
                wxDownloadImage: function (options) {
                    var key = this._core.register('download_image', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'download_image', key);
                    this._driver.delegate('download_image', options, this._driver['client_info']);
                },
                wxGetLocalImgData: function (options) {
                    var key = this._core.register('get_local_img_data', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'get_local_img_data', key);
                    this._driver.delegate('get_local_img_data', options, this._driver['client_info']);
                },
                wxDownloadVoice: function (options) {
                    var key = this._core.register('download_voice', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'download_voice', key);
                    this._driver.delegate('download_voice', options, this._driver['client_info']);
                },
                wxTranslateVoice: function (options) {
                    var key = this._core.register('translate_voice', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'translate_voice', key);
                    this._driver.delegate('translate_voice', options, this._driver['client_info']);
                },
                getNetworkType: function (options) {
                    var key = this._core.register('get_network_type', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'get_network_type', key);
                    this._driver.delegate('get_network_type', options, this._driver['client_info']);
                },
                openLocation: function (options) {
                    var key = this._core.register('open_location', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'open_location', key);
                    this._driver.delegate('open_location', options, this._driver['client_info']);
                },
                wxStartSearchBeacons: function (options) {
                    var key = this._core.register('start_search_beacons', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'start_search_beacons', key);
                    this._driver.delegate('start_search_beacons', options, this._driver['client_info']);
                },
                wxStopSearchBeacons: function (options) {
                    var key = this._core.register('stop_search_beacons', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'stop_search_beacons', key);
                    this._driver.delegate('stop_search_beacons', options, this._driver['client_info']);
                },
                wxOnSearchBeacons: function (options) {
                    var key = this._core.register('on_search_beacons', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'on_search_beacons', key);
                    this._driver.delegate('on_search_beacons', options, this._driver['client_info']);
                },
                wxHideMenuItems: function (options) {
                    var key = this._core.register('hide_menu_items', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'hide_menu_items', key);
                    this._driver.delegate('hide_menu_items', options, this._driver['client_info']);
                },
                wxShowMenuItems: function (options) {
                    var key = this._core.register('show_menu_items', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'show_menu_items', key);
                    this._driver.delegate('show_menu_items', options, this._driver['client_info']);
                },
                wxHideAllNonBaseMenuItem: function (options) {
                    var key = this._core.register('hide_all_non_base_menu_item', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'hide_all_non_base_menu_item', key);
                    this._driver.delegate('hide_all_non_base_menu_item', options, this._driver['client_info']);
                },
                wxShowAllNonBaseMenuItem: function (options) {
                    var key = this._core.register('show_all_non_base_menu_item', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'show_all_non_base_menu_item', key);
                    this._driver.delegate('show_all_non_base_menu_item', options, this._driver['client_info']);
                },
                wxOpenProductSpecificView: function (options) {
                    var key = this._core.register('open_product_specific_view', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'open_product_specific_view', key);
                    this._driver.delegate('open_product_specific_view', options, this._driver['client_info']);
                },
                wxChooseCard: function (options) {
                    var key = this._core.register('choose_card', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'choose_card', key);
                    this._driver.delegate('choose_card', options, this._driver['client_info']);
                },
                wxAddCard: function (options) {
                    var key = this._core.register('add_card', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'add_card', key);
                    this._driver.delegate('add_card', options, this._driver['client_info']);
                },
                wxOpenCard: function (options) {
                    var key = this._core.register('open_card', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'open_card', key);
                    this._driver.delegate('open_card', options, this._driver['client_info']);
                },
                wxChooseWXPay: function (options) {
                    var key = this._core.register('choose_wx_pay', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'choose_wx_pay', key);
                    this._driver.delegate('choose_wx_pay', options, this._driver['client_info']);
                },
                openAddress: function (options) {
                    var key = this._core.register('open_address', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'open_address', key);
                    this._driver.delegate('open_address', options, this._driver['client_info']);
                },
                modifyDeliveryName: function (options) {
                    var key = this._core.register('modify_delivery_name', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'modify_delivery_name', key);
                    this._driver.delegate('modify_delivery_name', options, this._driver['client_info']);
                },
                defineMenu: function (options) {
                    var key = this._core.register('define_menu', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'define_menu', key);
                    this._driver.delegate('define_menu', options, this._driver['client_info']);
                },
                convertVideo: function (options) {
                    var key = this._core.register('convert_video', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'convert_video', key);
                    this._driver.delegate('convert_video', options, this._driver['client_info']);
                },
                checkJsApi: function (options) {
                    var key = this._core.register('check_js_api', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'check_js_api', key);
                    this._driver.delegate('check_js_api', options, this._driver['client_info']);
                },
                selectMedia: function (options) {
                    var key = this._core.register('select_media', options.completed, options.once, options.timeout);
                    options = optionLoadEvent(options, 'select_media', key);
                    this._driver.delegate('select_media', options, this._driver['client_info']);
                },
                subscribeEvent: function (options) {
                    var key = this._core.register('subscribe_event', options.completed, false, null);
                    options = optionLoadEvent(options, 'subscribe_event', key);
                    this._driver.delegate('subscribe_event', options, this._driver['client_info']);
                },
                preview: function (options) {
                    var key = this._core.register('preview', options.completed, true, options.timeout);
                    options = optionLoadEvent(options, 'preview', key);
                    this._driver.delegate('preview', options, this._driver['client_info']);
                },
                payForReading: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('pay_for_reading', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'pay_for_reading', key);
                    this._driver.delegate('pay_for_reading', data, this._driver['client_info']);
                },
                setTopBar: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('set_top_bar', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'set_top_bar', key);
                    this._driver.delegate('set_top_bar', data, this._driver['client_info']);
                },
                openNewPage: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('open_new_page', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'open_new_page', key);
                    this._driver.delegate('open_new_page', data, this._driver['client_info']);
                },
                emit: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('emit', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'emit', key);
                    this._driver.delegate('emit', data, this._driver['client_info']);
                },
                openLaunchWeapp: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('open_launch_weapp', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'open_launch_weapp', key);
                    this._driver.delegate('open_launch_weapp', data, this._driver['client_info']);
                },
                downloadFile: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('download_file', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'download_file', key);
                    this._driver.delegate('download_file', data, this._driver['client_info']);
                },
                openHooApp: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('open_hoo_app', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'open_hoo_app', key);
                    this._driver.delegate('open_hoo_app', data, this._driver['client_info']);
                },
                goHomepage: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('go_homepage', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'go_homepage', key);
                    this._driver.delegate('go_homepage', data, this._driver['client_info']);
                },
                changeStatusStyle: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('change_status_style', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'change_status_style', key);
                    this._driver.delegate('change_status_style', data, this._driver['client_info']);
                },
                showDyModeVideos: function (callback, once, data) {
                    data = filterParams(callback, once, data);
                    var key = this._core.register('show_dy_mode_videos', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'show_dy_mode_videos', key);
                    this._driver.delegate('show_dy_mode_videos', data, this._driver['client_info']);
                },
                playAudio: function(callback, once, data){
                    data = filterParams(callback, once, data);
                    var key = this._core.register('play_audio', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'play_audio', key);
                    this._driver.delegate('play_audio', data, this._driver['client_info']);
                },
                pauseAudio: function(callback, once, data){
                    data = filterParams(callback, once, data);
                    var key = this._core.register('pause_audio', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'pause_audio', key);
                    this._driver.delegate('pause_audio', data, this._driver['client_info']);
                },
                queryAudio: function(callback, once, data){
                    data = filterParams(callback, once, data);
                    var key = this._core.register('query_audio', data.completed, data.once, data.timeout);
                    data = optionLoadEvent(data, 'query_audio', key);
                    this._driver.delegate('query_audio', data, this._driver['client_info']);
                }
            };
            initcallback(apis);
        } catch (e) {
            Tools.writelog('Error name:', e.name);
            Tools.writelog('Error ', e.message);
            Tools.writelog('Error detail', e);
            Tools.setError({ code: 103, msg: e.name, data: e });
        }
    };
    return CallService(initcallback);
});